import { ComplementsCreateSelectPage } from './../pages/complements/complements-create-select/complements-create-select';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { HttpModule } from '@angular/http';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { Printer } from '@ionic-native/printer';

import { EscapeHtmlPipe } from '../pipes/keep-html.pipe';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import localeCa from '@angular/common/locales/ca';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { CurrencyPipe } from '@angular/common';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeCa, 'ca');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function setTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/*CONFIGURATION*/
import { ConfigurationServices } from "../pages/configuration/services";
import { SideMenuPageConfig } from "../pages/components/side-menu-config/side-menu-config";
import { ConfigurationPage } from "../pages/configuration/configuration";
import { ConfigurationEstablishmentCreatePage } from "../pages/configuration/configuration-establishment/configuration-establishment-create/configuration-establishment-create";
import { ConfigurationPasswordPage } from "../pages/configuration/configuration-password/configuration-password";
import { ConfigurationUsersPage } from "../pages/configuration/configuration-users/configuration-users";
import { ConfigurationUsersCreatePage } from "../pages/configuration/configuration-users/configuration-users-create/configuration-users-create";
import { ConfigurationRoomsPage } from "../pages/configuration/configuration-rooms/configuration-rooms";
import { ConfigurationRoomsCreatePage } from "../pages/configuration/configuration-rooms/configuration-rooms-create/configuration-rooms-create";
import { ConfigurationRoomsCreateTablePage } from "../pages/configuration/configuration-rooms/configuration-rooms-create/configuration-rooms-create-table/configuration-rooms-create-table";
import { ConfigurationTicketsPage } from "../pages/configuration/configuration-tickets/configuration-tickets";
import { ConfigurationTicketsCreatePage } from "../pages/configuration/configuration-tickets/configuration-tickets-create/configuration-tickets-create";
import { ConfigurationTicketsListPage } from "../pages/configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list";
import { ConfigurationCashsPage } from "../pages/configuration/configuration-cashs/configuration-cashs";
import { ConfigurationCashsCreatePage } from "../pages/configuration/configuration-cashs/configuration-cashs-create/configuration-cashs-create";
import { ConfigurationVariationsPage } from "../pages/configuration/configuration-variations/configuration-variations";
import { ConfigurationVariationCreateSelectTypePage } from "../pages/configuration/configuration-variations/configuration-variations-create/configuration-variation-create-select-type/configuration-variation-create-select-type";
import { ConfigurationVariationCreateListPage } from "../pages/configuration/configuration-variations/configuration-variations-create/configuration-variation-create-list/configuration-variation-create-list";
import { ConfigurationVariationsCreateInfoPage } from "../pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variations-create-info";

/*PRINCIPAL PAGES*/
import { MyApp } from './app.component';
import { LoginPage } from '../pages/auth/login/login';
import { HomePage } from '../pages/home/home';

/*DISH*/
import { DishServices } from "../pages/dish/services";
import { FilterPipe } from '../pages/dish/filter.pipe';
import { IngredientsSelectPipe } from "../pipes/ingredients-select-pipe";
import { DishListPage } from '../pages/dish/dish-list/dish-list';
import { DishCreateNamePage } from '../pages/dish/dish-create/dish-create-name/dish-create-name';
import { DishCreatePricePage } from '../pages/dish/dish-create/dish-create-price/dish-create-price';
import { DishPartialTagsPage } from '../pages/dish/dish-create/dish-create-name/dish-partial-tags/dish-partial-tags';
import { DishTablePage } from "../pages/dish/dish-table/dish-table";
import { DishCreateAllergensPage } from "../pages/dish/dish-create/dish-create-allergens/dish-create-allergens";
import { DishPartialAllergensPage } from '../pages/dish/dish-create/dish-create-allergens/dish-partial-allergens/dish-partial-allergens';
import { DishPartialIndicatorsPage } from "../pages/dish/dish-create/dish-create-allergens/dish-partial-indicators/dish-partial-indicators";
import { DishCreateImagePage } from "../pages/dish/dish-create/dish-create-image/dish-create-image";
import { DishCreateFinishPage } from "../pages/dish/dish-create/dish-create-finish/dish-create-finish";
import { DishViewPage } from "../pages/dish/dish-view/dish-view/dish-view";
import { DishViewNamePage } from "../pages/dish/dish-view/dish-view-name/dish-view-name";
import { DishViewTopPage } from "../pages/dish/dish-view/dish-view-top/dish-view-top";
import { DishViewTagsPage } from "../pages/dish/dish-view/dish-view-tags/dish-view-tags";
import { DishViewAllergensPage } from "../pages/dish/dish-view/dish-view-allergens/dish-view-allergens";
import { DishViewListPage } from "../pages/dish/dish-view/dish-view-list/dish-view-list";
import { DishViewPreparationPage } from "../pages/dish/dish-view/dish-view-preparation/dish-view-preparation";
import { DishViewPhotoPage } from "../pages/dish/dish-view/dish-view-photo/dish-view-photo";
import { DishViewGraphicsPage } from "../pages/dish/dish-view/dish-view-graphics/dish-view-graphics";
import { DishIngredientsSelectPage } from "../pages/dish/dish-create/dish-cost/dish-ingredients-select/dish-ingredients-select";
import { DishPartialIngredientsSelectPage } from "../pages/dish/dish-create/dish-cost/dish-ingredients-select/dish-partial-ingredients-select/dish-partial-ingredients-select";
import { DishPartialIngredientsSelectedPage } from "../pages/dish/dish-create/dish-cost/dish-ingredients-select/dish-partial-ingredients-selected/dish-partial-ingredients-selected";
import { DishIngredientsQuantityPage } from "../pages/dish/dish-create/dish-cost/dish-ingredients-quantity/dish-ingredients-quantity";
import { DishPreparationPage } from "../pages/dish/dish-create/dish-cost/dish-preparation/dish-preparation";
import { DishFoodcostPersonsPage } from '../pages/dish/dish-view/dish-foodcost-persons/dish-foodcost-persons';

/*MENU*/
import { MenuListPage } from "../pages/menu/menu-list/menu-list";
import { MenuPartialRatioPage } from "../pages/menu/menu-list/menu-partial-ratio/menu-partial-ratio";
import { MenuPartialSharePage } from "../pages/menu/menu-list/menu-partial-share/menu-partial-share";
import { MenuCreateSelectTypePage } from "../pages/menu/menu-create/menu-create-select-type/menu-create-select-type";
import { MenuCreateTitlePage } from "../pages/menu/menu-create/menu-create-title/menu-create-title";
import { MenuCreateDishSelectPage } from "../pages/menu/menu-create/menu-create-dish-select/menu-create-dish-select";
import { MenuPartialDishesSelectPage } from "../pages/menu/menu-create/menu-create-dish-select/menu-partial-dishes-select/menu-partial-dishes-select";
import { MenuPartialDishesSelectedPage } from "../pages/menu/menu-create/menu-create-dish-select/menu-partial-dishes-selected/menu-partial-dishes-selected";
import { MenuCreatePricenextrasPage } from "../pages/menu/menu-create/menu-create-pricenextras/menu-create-pricenextras";
import { MenuCreateCustomizeViewPage } from "../pages/menu/menu-view/menu-create-customize-view";
import { MenuPartialCustomizeOptionsPage } from "../pages/menu/menu-view/menu-partial-customize-options/menu-partial-customize-options";
import { MenuPartialCustomizeViewPage } from "../pages/menu/menu-view/menu-partial-customize-view/menu-partial-customize-view";
import { MenuServices } from "../pages/menu/services";
import { FilterMenuPipe } from '../pages/menu/filter.pipe';
import { MenuPartialCustomizeEditablePage } from "../pages/menu/menu-view/menu-partial-customize-editable/menu-partial-customize-editable";
import { MenuDishPipe } from "../pages/menu/menu-create/menu-create-dish-select/menu-partial-dishes-select/menu-dish-select-pipe";
import { MenuXxssPage } from "../pages/menu/menu-xxss/menu-xxss";
import { MenuPageCustomizeSeparatorsPage } from "../pages/menu/menu-view/menu-partial-customize-options/menu-page-customize-separators/menu-page-customize-separators";
import { MenuPageCustomizeTemplatPage } from "../pages/menu/menu-view/menu-partial-customize-options/menu-page-customize-template/menu-page-customize-template";

/*INGREDIENTS*/
import { FilterPipeIngredients } from "../pages/ingredients/ingredient-list/filter.pipe";
import { IngredientsServices } from "../pages/ingredients/services";
import { IngredientListPage } from "../pages/ingredients/ingredient-list/ingredient-list";
import { IngredientCreateInfoPage } from "../pages/ingredients/ingredient-create/ingredient-create-info/ingredient-create-info";
import { IngredientPartialTagsPage } from "../pages/ingredients/ingredient-create/ingredient-create-info/ingredient-partial-tags/ingredient-partial-tags";
import { IngredientCreateAllergensPage } from "../pages/ingredients/ingredient-create/ingredient-create-allergens/ingredient-create-allergens";
import { IngredientPartialAllergensPage } from "../pages/ingredients/ingredient-create/ingredient-create-allergens/ingredient-partial-allergens/ingredient-partial-allergens";
import { IngredientPartialIndicatorsPage } from "../pages/ingredients/ingredient-create/ingredient-create-allergens/ingredient-partial-indicators/ingredient-partial-indicators";
import { IngredientCreateSelectProviderPage } from "../pages/ingredients/ingredient-create/ingredient-create-select-provider/ingredient-create-select-provider";
import { IngredientPartialProviderSelectPage } from "../pages/ingredients/ingredient-create/ingredient-create-select-provider/ingredient-partial-provider-select/ingredient-partial-provider-select";
import { IngredientPartialProviderSelectedPage } from "../pages/ingredients/ingredient-create/ingredient-create-select-provider/ingredient-partial-provider-selected/ingredient-partial-provider-selected";
import { IngredientCreateProviderPricePage } from "../pages/ingredients/ingredient-create/ingredient-create-provider-price/ingredient-create-provider-price";
import { IngredientCompCreateInfoPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-info/ingredient-comp-create-info";
import { IngredientCompPartialTagsPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-info/ingredient-comp-partial-tags/ingredient-comp-partial-tags";
import { IngredientCreateStockPage } from "../pages/ingredients/ingredient-create/ingredient-create-stock/ingredient-create-stock";
import { IngredientCompCreateSelectIngPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-create-select-ing";
import { IngredientCompPartialIngSelectPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-partial-ing-select/ingredient-comp-partial-ing-select";
import { IngredientCompPartialIngSelectedPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-partial-ing-selected/ingredient-comp-partial-ing-selected";
import { IngredientCompQuantityCostPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-quantity-cost/ingredient-comp-quantity-cost";
import { IngredientCompCreateStock } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-stock/ingredient-comp-create-stock";
import { IngredientViewPage } from "../pages/ingredients/ingredient-view/ingredient-view/ingredient-view";
import { IngredientViewNamePage } from "../pages/ingredients/ingredient-view/ingredient-view-name/ingredient-view-name";
import { IngredientViewTagsPage } from "../pages/ingredients/ingredient-view/ingredient-view-tags/ingredient-view-tags";
import { IngredientViewAllergensPage } from "../pages/ingredients/ingredient-view/ingredient-view-allergens/ingredient-view-allergens";
import { IngredientViewGraphicsPage } from "../pages/ingredients/ingredient-view/ingredient-view-graphics/ingredient-view-graphics";
import { IngredientViewFoodcostPage } from "../pages/ingredients/ingredient-view/ingredient-view-foodcost/ingredient-view-foodcost";
import { IngredientViewStockPage } from "../pages/ingredients/ingredient-view/ingredient-view-stock/ingredient-view-stock";
import { ProvidersSelectPipe } from "../pages/ingredients/ingredient-create/ingredient-create-select-provider/ingredient-partial-provider-select/providers-select-pipe";
import { IngredientCompCreatePreparationPage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-preparation/ingredient-comp-create-preparation";
import { IngredientCompCreateImagePage } from "../pages/ingredients/ingredient-comp-create/ingredient-comp-create-image/ingredient-comp-create-image";
import { IngredientViewPreparationPage } from "../pages/ingredients/ingredient-view/ingredient-view-preparation/ingredient-view-preparation";
import { IngredientViewPhotoPage } from "../pages/ingredients/ingredient-view/ingredient-view-photo/ingredient-view-photo";
import { IngredientCreateSelectType } from "../pages/ingredients/ingredient-create-select-type/ingredient-create-select-type";
import { IngredientsMeasurementComponent } from "../components/ingredients-measurement/ingredients-measurement";

/*PRODUCTS*/
import { FilterPipeProduct } from "../pages/products/filter.pipe";
import { ProductListPage } from "../pages/products/product-list/product-list";
import { ProductCreateSelectTypePage } from "../pages/products/product-create/product-create-select-type/product-create-select-type";
import { ProductCreateWfoodcostInfoPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info";
import { ProductCreateWfoodcostStockPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-stock/product-create-wfoodcost-stock";
import { ProductPartialWfoodcostTagsPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-partial-wfoodcost-tags/product-partial-wfoodcost-tags";
import { ProductCreateWfoodcostAllergensPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-create-wfoodcost-allergens";
import { ProductPartialWfoodcostAllergensPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-partial-wfoodcost-allergens/product-partial-wfoodcost-allergens";
import { ProductPartialWfoodcostIndicatorsPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-partial-wfoodcost-indicators/product-partial-wfoodcost-indicators";
import { ProductCreateWfoodcostSelectProviderPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-create-wfoodcost-select-provider";
import { ProductPartialWfoodcostProviderSelectPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-partial-wfoodcost-provider-select/product-partial-wfoodcost-provider-select";
import { ProductPartialWfoodcostProviderSelectedPage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-partial-wfoodcost-provider-selected/product-partial-wfoodcost-provider-selected";
import { ProductCreateWfoodcostProviderPricePage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-provider-price/product-create-wfoodcost-provider-price";
import { ProductCreateWfoodcostImagePage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-image/product-create-wfoodcost-image";
import { ProductCreateWfoodcostPricePage } from "../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-price/product-create-wfoodcost-price";
import { ProductCreateFoodcostInfoPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-info/product-create-foodcost-info";
import { ProductPartialFoodcostTagsPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-info/product-partial-foodcost-tags/product-partial-foodcost-tags";
import { ProductCreateFoodcostSelectIngPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-create-foodcost-select-ing";
import { ProductPartialFoodcostIngSelectedPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-partial-foodcost-ing-selected/product-partial-foodcost-ing-selected";
import { ProductPartialFoodcostIngSelectPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-partial-foodcost-ing-select/product-partial-foodcost-ing-select";
import { ProductCreateFoodcostQuantityCostPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-quantity-cost/product-create-foodcost-quantity-cost";
import { ProductCreateFoodcostPreparationPage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-preparation/product-create-foodcost-preparation";
import { ProductCreateFoodcostImagePage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-image/product-create-foodcost-image";
import { ProductCreateFoodcostPricePage } from "../pages/products/product-create/product-create-foodcost/product-create-foodcost-price/product-create-foodcost-price";
import { ProductViewPage } from "../pages/products/product-view/product-view/product-view";
import { ProductViewNamePage } from "../pages/products/product-view/product-view-name/product-view-name";
import { ProductViewStockPage } from "../pages/products/product-view/product-view-stock/product-view-stock";
import { ProductViewTopPage } from "../pages/products/product-view/product-view-top/product-view-top";
import { ProductViewAllergensPage } from "../pages/products/product-view/product-view-allergens/product-view-allergens";
import { ProductViewTagsPage } from "../pages/products/product-view/product-view-tags/product-view-tags";
import { ProductViewListPage } from "../pages/products/product-view/product-view-list/product-view-list";
import { ProductViewPreparationPage } from "../pages/products/product-view/product-view-preparation/product-view-preparation";
import { ProductViewPhotoPage } from "../pages/products/product-view/product-view-photo/product-view-photo";
import { ProductViewGraphicsPage } from "../pages/products/product-view/product-view-graphics/product-view-graphics";
import { ProductsServices } from "../pages/products/services";

/*PROVIDERS*/
import { ProvidersServices } from "../pages/providers/services";
import { ProvidersCreateDataPage } from "../pages/providers/providers-create/providers-create-data/providers-create-data";

/*RESERVATION*/
import { ReservationsServices } from "../pages/reservation/services";
import { ReservationCalendarPage } from "../pages/reservation/reservation-calendar/reservation-calendar";
import { ReservationDayPage } from "../pages/reservation/reservation-day/reservation-day";
import { ReservationCreatePage } from "../pages/reservation/reservation-create/reservation-create";

/*TPV*/
import { TpvRoomPage } from "../pages/tpv/tpv-select/tpv-select";
import { TpvRoomMenuPage } from "../pages/tpv/tpv-select/tpv-select-menu/tpv-select-menu";
import { TpvSelectRoomPage } from "../pages/tpv/tpv-select/tpv-select-room/tpv-select-room";
import { TPVServices } from "../pages/tpv/services";
import { TpvTicketPage } from "../pages/tpv/tpv-ticket/tpv-ticket";
import { TpvTicketMenuPage } from "../pages/tpv/tpv-ticket/tpv-ticket-menu/tpv-ticket-menu";
import { TpvTicketSelectPage } from "../pages/tpv/tpv-ticket/tpv-ticket-select/tpv-ticket-select";
import { TpvTicketSelectedPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected";
import { TpvLoaderPage } from "../pages/tpv/tpv-loader/tpv-loader";
import { TpvTicketSelectedListTicketPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-list-ticket/tpv-ticket-selected-list-ticket";
import { TpvCashInoutCreatePage } from "../pages/tpv/tpv-cash-inout-create/tpv-cash-inout-create";
import { TpvTicketSelectedPersonsPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-persons/tpv-ticket-selected-persons";
import { TpvKeyboardExportableComponent } from "../components/tpv-keyboard-exportable/tpv-keyboard-exportable";
import { TpvTicketSelectedListTicketPrintPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-list-ticket-print/tpv-ticket-selected-list-ticket-print";
import { TpvTicketSelectedCashPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-cash/tpv-ticket-selected-cash";
import { TpvTicketSelectedPayPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay/tpv-ticket-selected-pay";
import { TpvTicketSelectedPayIndvPage } from "../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay-indv/tpv-ticket-selected-pay-indv";

/*STOCK*/
import { StockServices } from "../pages/stock/services";
import { StockListPage } from "../pages/stock/stock-list/stock-list";
import { StockProviderListPage } from "../pages/stock/stock-provider-list/stock-provider-list";
import { DeliberyNoteListPage } from "../pages/delibery_note/delibery-note-list/delibery-note-list";

/*DELIBERY_NOTE*/
import { DeliberyNoteServices } from "../pages/delibery_note/services";
import { DeliberyNoteCreateSelectProviderPage } from "../pages/delibery_note/delibery-note-create/delibery-note-create-select-provider/delibery-note-create-select-provider";
import { DeliberyNoteCreateSelectIngprodPage } from "../pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-select-ingprod";
import { DeliberyNoteCreatePartialIngprodSelectPage } from "../pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-partial-ingprod-select/delibery-note-create-partial-ingprod-select";
import { DeliberyNoteCreatePartialIngprodSelectedPage } from "../pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-partial-ingprod-selected/delibery-note-create-partial-ingprod-selected";
import { ProdingsSelectPipe } from "../pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-partial-ingprod-select/prodings-select-pipe";
import { DeliberyNoteCreateIngprodPricePage } from "../pages/delibery_note/delibery-note-create/delibery-note-create-ingprod-price/delibery-note-create-ingprod-price";
import { DeliberyNoteViewPage } from "../pages/delibery_note/delibery-note-view/delibery-note-view/delibery-note-view";
import { DeliberyNoteViewInfoPage } from "../pages/delibery_note/delibery-note-view/delibery-note-view-info/delibery-note-view-info";
import { DeliberyNoteViewListPage } from "../pages/delibery_note/delibery-note-view/delibery-note-view-list/delibery-note-view-list";

/*INCOME EXPENSES*/
import { IncomeExpensesServices } from "../pages/income-expenses/services";
import { IncomeExpensesListPage } from "../pages/income-expenses/income-expenses-list/income-expenses-list";
import { IncomeCreateDataPage } from "../pages/income-expenses/income-create/income-create-data/income-create-data";
import { ExpensesCreateDataPage } from "../pages/income-expenses/expenses-create/expenses-create-data/expenses-create-data";

/*CUSTOMERS*/
import { CustomersServices } from "../pages/customers/services";
import { CustomersListPage } from "../pages/customers/customers-list/customers-list";
import { CustomersCreateDataPage } from "../pages/customers/customers-create/customers-create-data/customers-create-data";

/*INVOICES*/
import { InvoicesServices } from "../pages/invoices/services";
import { InvoicesCreateSelectClientPage } from "../pages/invoices/invoices-create/invoices-create-select-client/invoices-create-select-client";
import { InvoicesListPage } from "../pages/invoices/invoices-list/invoices-list";
import { InvoicesViewPage } from "../pages/invoices/invoices-view/invoices-view";

/*KITCHEN*/
import { KitchenPage } from "../pages/kitchen/kitchen";
import { KitchenHistoryPage } from "../pages/kitchen/kitchen-history/kitchen-history";

/*Auth*/
import { AuthServices } from "../pages/auth/services";

/*Help*/
import { HelpPage } from "../pages/help/help";

/*Static*/
import { StaticsUpdatePage } from "../pages/statics-update/statics-update";

/*Components Generals*/
import { PartialPageTitlePage } from '../pages/components/partial-page-title/partial-page-title';
import { HeaderPage } from '../pages/components/header/header';
import { HeaderSchoolPage } from '../pages/components/header-school/header-school';
import { SideMenuPage } from '../pages/components/side-menu/side-menu';
import { AllergensPage } from '../pages/components/allergens/allergens';
import { UploadImagePage } from "../pages/components/upload-image/upload-image";
import { TagsPage } from "../pages/components/tags/tags";
import { HelpBottomPage } from '../pages/components/help-bottom/help-bottom';
import { NameLangPage } from '../pages/components/name-lang/name-lang';
import { StaticAlertPage } from '../pages/components/static-alert/static-alert';

/*PIPES*/
import { FilterPipeDeliberyNote } from "../pages/delibery_note/delibery-note-list/filter.pipe";
import { FilterPipeProvider } from "../pages/providers/filter.pipe";
import { FilterPipeTicketOpen } from "../pages/configuration/configuration-tickets/filter-topen.pipe";
import { FilterPipeTicketClosed } from "../pages/configuration/configuration-tickets/filter-tclosed.pipe";
import { FilterPipeCloseCash } from "../pages/configuration/configuration-close-cash/filter.pipe";
import { FilterPipeVariations } from "../pages/configuration/configuration-variations/filter.pipe";
import { FilterPipeCustomer } from "../pages/customers/filter.pipe";
import { FilterPipeComplements } from './../pages/configuration/configuration-complements/filter.pipe';


/*Globals*/
import { Globals } from '../globals';
import { Uploads } from "../pages/services/uploads";

//Others modules
import { IonTagsInputModule } from "ionic-tags-input";
import { TemplatesServices } from "../pages/services/templates";
import { SeparatorServices } from "../pages/services/separators";
import { HTTP } from '@ionic-native/http';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { PrintServices } from "../pages/services/printServices";
import { ExportServices } from "../pages/services/exportServices";
import { NativeAudio } from '@ionic-native/native-audio/ngx';


/*ANGULAR FIREBASE*/
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database-deprecated';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { HttpClientModule } from '@angular/common/http';


//********** firebase configuration  ************ */


export const config = {
    apiKey: "AIzaSyBlPzO-Z9DKVlJsdCLFSAjUwpsoiXzq3v8",
    authDomain: "mycheftool-d3899.firebaseapp.com",
    databaseURL: "https://mycheftool-d3899.firebaseio.com",
    projectId: "mycheftool-d3899",
    storageBucket: "mycheftool-d3899.appspot.com",
    messagingSenderId: "934198322702"
};



/*export const config = {
    apiKey: "AIzaSyCtplAgjeAW6cBLO9hQcFaNnhde6M3Zfj8",
    authDomain: "mycheftool-debug.firebaseapp.com",
    databaseURL: "https://mycheftool-debug.firebaseio.com",
    projectId: "mycheftool-debug",
    storageBucket: "mycheftool-debug.appspot.com",
    messagingSenderId: "150131355639",
    appId: "1:150131355639:web:650b8c66ee0cf49b"
};*/


/*ANGULAR ROLLBAR */
import * as Rollbar from 'rollbar';
import {
    Injectable,
    Injector,
    InjectionToken
} from '@angular/core';

const rollbarConfig = {
    accessToken: '380d9e8edd944198b36a1e1d46391bb3',
    captureUncaught: true,
    captureUnhandledRejections: true,
};

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) {
    }

    handleError(err: any): void {
        var rollbar = this.injector.get(RollbarService);
        rollbar.error(err.originalError || err);
    }
}

export function rollbarFactory() {
    return new Rollbar(rollbarConfig);
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');




/*CALENDAR*/
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ReservationLoaderPage } from "../pages/reservation/reservation-loader/reservation-loader";

/*DATE*/
import { DatePipe } from '@angular/common';
import { FilterPipeIncomes } from "../pages/income-expenses/income-create/filter.pipe";
import { FilterPipeExpenses } from "../pages/income-expenses/expenses-create/filter.pipe";


// Import Angular2 plugin.
import { OrdersServices } from "../pages/kitchen/services";
import { SuperPage } from "../pages/auth/super/super";
import { PasswordRecoveryPage } from "../pages/auth/password-recovery/password-recovery";

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { SetupPage } from "../pages/setup/setup-initial/setup";
import { SetupInital2Page } from "../pages/setup/setup-initial-2/setup-inital-2";
import { MenuPartialCustomizeViewA5Page } from "../pages/menu/menu-view/menu-partial-customize-view/menu-partial-customize-view-a5/menu-partial-customize-view-a5";
import { HiddenScreenPage } from "../pages/components/hidden-screen/hidden-screen";
import { ConfigurationImagesPage } from "../pages/configuration/configuration-images/configuration-images";
import { FinishProcessPage } from '../pages/finish-process/finish-process';
import { StaticsServices } from '../pages/services/statics';


/*ORDERS*/
import { OrdersCoServices } from '../pages/orders/services';
import { OrdersLoaderPage } from '../pages/orders/orders-loader/orders-loader';
import { OrdersRoomPage } from '../pages/orders/orders-rooms/orders-rooms';
import { OrdersSelectRoomPage } from '../pages/orders/orders-rooms/orders-select-room/orders-select-room';
import { OrdersSelectRoomMenuPage } from '../pages/orders/orders-rooms/orders-select-room-menu/orders-select-room-menu';
import { OrdersTablePage } from '../pages/orders/orders-table/orders-table';
import { OrdersTableInfoPage } from '../pages/orders/orders-table/orders-table-info/orders-table-info';
import { OrdersTableListPage } from '../pages/orders/orders-table/orders-table-list/orders-table-list';
import { OrdersTableButtonsPage } from '../pages/orders/orders-table/orders-table-buttons/orders-table-buttons';
import { OrdersSelectPage } from '../pages/orders/orders-select/orders-select';
import { OrdersSelectSelectPage } from '../pages/orders/orders-select/orders-select-select/orders-select-select';
import { OrdersSelectMenuPage } from '../pages/orders/orders-select/orders-select-menu/orders-select-menu';
import { OrdersSelectSelectedPage } from '../pages/orders/orders-select/orders-select-selected/orders-select-selected';
import { OrdersSelectSelectedListPage } from '../pages/orders/orders-select/orders-select-selected/orders-select-selected-list/orders-select-selected-list';
import { OrdersUpDelPage } from '../pages/orders/orders-updel/orders-updel';
import { OrdersSelectSelectedPersonsPage } from '../pages/orders/orders-select/orders-select-selected/orders-select-selected-persons/orders-select-selected-persons';
import { OrdersKeyboardExportableComponent } from '../components/orders-keyboard-exportable/orders-keyboard-exportable';
import { OrdersPositionsPage } from '../pages/orders/orders-positions/orders-positions';
import { OrdersTableInfoPrintPage } from '../pages/orders/orders-table/orders-table-info-print/orders-table-info-print';

/*TUTORIALS SLIDER*/
import { DishTutorialSlidePage } from '../pages/help/tutorial-slider/dish-tutorial-slide/dish-tutorial-slide';
import { MenuTutorialSlidePage } from '../pages/help/tutorial-slider/menu-tutorial-slide/menu-tutorial-slide';
import { ProductTutorialSlidePage } from '../pages/help/tutorial-slider/product-tutorial-slide/product-tutorial-slide';
import { IngredientTutorialSlidePage } from '../pages/help/tutorial-slider/ingredient-tutorial-slide/ingredient-tutorial-slide';
import { TpvTutorialSlidePage } from '../pages/help/tutorial-slider/tpv-tutorial-slide/tpv-tutorial-slide';
import { ReservationTutorialSlidePage } from '../pages/help/tutorial-slider/reservation-tutorial-slide/reservation-tutorial-slide';
import { StockTutorialSlidePage } from '../pages/help/tutorial-slider/stock-tutorial-slide/stock-tutorial-slide';
import { InexpTutorialSlidePage } from '../pages/help/tutorial-slider/inexp-tutorial-slide/inexp-tutorial-slide';
import { ConfigurationTutorialSlidePage } from '../pages/help/tutorial-slider/configuration-tutorial-slide/configuration-tutorial-slide';
import { AddonsTutorialSlidePage } from '../pages/help/tutorial-slider/addons-tutorial-slide/addons-tutorial-slide';
import { DashboardTutorialSlidePage } from '../pages/help/tutorial-slider/dashboard-tutorial-slide/dashboard-tutorial-slide';

/*TAKEAWAY*/
import { TakeawayServices } from '../pages/takeaway/services';
import { TakeawayLoaderPage } from '../pages/takeaway/takeaway-loader/takeaway-loader';
import { TakeawayOrdersPage } from '../pages/takeaway/takeaway-orders/takeaway-orders';
import { TakeawayOrdersMenuPage } from '../pages/takeaway/takeaway-orders/takeaway-orders-menu/takeaway-orders-menu';
import { TakeawaySelectOrdersPage } from '../pages/takeaway/takeaway-orders/takeaway-select-orders/takeaway-select-orders';
import { TakeawayCreateSelectCustomerPage } from '../pages/takeaway/takeaway-create/takeaway-create-select-customer/takeaway-create-select-customer';
import { TakeawayOrderButtonsPage } from '../pages/takeaway/takeaway-order/takeaway-order-buttons/takeaway-order-buttons';
import { TakeawayOrderInfoPage } from '../pages/takeaway/takeaway-order/takeaway-order-info/takeaway-order-info';
import { TakeawayOrderPage } from '../pages/takeaway/takeaway-order/takeaway-order';
import { TakeawayOrderInfoPrintPage } from '../pages/takeaway/takeaway-order/takeaway-order-info-print/takeaway-order-info-print';
import { TakeawayOrderListPage } from '../pages/takeaway/takeaway-order/takeaway-order-list/takeaway-order-list';
import { TakeawayOrderSelectPage } from '../pages/takeaway/takeaway-order-select/takeaway-order-select';
import { TakeawayOrderSelectSelectPage } from '../pages/takeaway/takeaway-order-select/takeaway-order-select-select/takeaway-order-select-select';
import { TakeawayOrderSelectSelectedPage } from '../pages/takeaway/takeaway-order-select/takeaway-order-select-selected/takeaway-order-select-selected';
import { TakeawayOrderSelectMenuPage } from '../pages/takeaway/takeaway-order-select/takeaway-order-select-menu/takeaway-order-select-menu';
import { TakeawayOrderSelectSelectedListPage } from '../pages/takeaway/takeaway-order-select/takeaway-order-select-selected/takeaway-order-select-selected-list/takeaway-order-select-selected-list';
import { TakeawayOrderUpDelPage } from '../pages/takeaway/takeaway-order-updel/takeaway-order-updel';
import { TakeawayOrderPayPage } from '../pages/takeaway/takeaway-order-pay/takeaway-order-pay';
import { TakeawayOrderInfoTicketPrintPage } from '../pages/takeaway/takeaway-order/takeaway-order-info-ticket-print/takeaway-order-info-ticket-print';
import { BlockScreenPage } from '../pages/components/block-screen/block-screen';
import { TpvTicketShowListDetailsPage } from '../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-show-list-details/tpv-ticket-show-list-details';
import { TakeawayOrderSelectSelectedPersonsPage } from '../pages/takeaway/takeaway-order-select/takeaway-order-select-selected/takeaway-order-select-selected-persons/takeaway-order-select-selected-persons';

import { MultiPage } from '../pages/auth/multi/multi';
import { FilterRestaurantsPipe } from '../pages/auth/filter.pipe';
import { MenuCreateFinishSectionPage } from '../pages/menu/menu-create/menu-create-finish-section/menu-create-finish-section';
import { AlertMessagePage } from '../pages/components/alert-message/alert-message';
//import {MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatButtonModule, MatProgressSpinnerModule} from '@angular/material';

//Home
import { WeatherPage } from '../pages/components/weather/weather';
import { SalesListPage } from '../pages/sales/sales-list/sales-list';
import { FilterPipeInvoices } from '../pages/invoices/filter.pipe';
import { SalesServices } from '../pages/sales/services';
import { ProgressBarPage } from '../pages/components/progress-bar/progress-bar';
import { ProviderOrderCartPage } from '../pages/providers/orders/provider-order-cart/provider-order-cart';
import { ProviderOrderAddPage } from '../pages/providers/orders/provider-order-add/provider-order-add';
import { ProviderOrderAddDishPage } from '../pages/providers/orders/provider-order-add-dish/provider-order-add-dish';
import { SalesAnalyticsPage } from '../pages/sales/sales-analytics/sales-analytics';
import { ProviderOrderListPage } from '../pages/providers/orders/provider-order-list/provider-order-list';
import { ProviderOrderViewPage } from '../pages/providers/orders/provider-order-view/provider-order-view';
import { TpvTicketSelectElementPage } from '../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-select-element/tpv-ticket-select-element';
import { TpvTicketDiscountRestaurantticketPage } from '../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-discount-restaurantticket/tpv-ticket-discount-restaurantticket';
import { TakeawayOrderDiscountRestaurantticketPage } from '../pages/takeaway/takeaway-order-discount-restaurantticket/takeaway-order-discount-restaurantticket';
import { FilterPipeProviderOrder } from '../pages/providers/orders/provider-order-list/filter.pipe';
//expenses delibery note
import { ExpensesDenoCreateDataPage } from '../pages/income-expenses/expenses-deno-create/expenses-deno-create-data/expenses-deno-create-data';
import { ExpensesDenoCreateSelectDenoPage } from '../pages/income-expenses/expenses-deno-create/expenses-deno-create-select-deno/expenses-deno-create-select-deno';
import { ExpensesDenoPartialDenoSelectPage } from '../pages/income-expenses/expenses-deno-create/expenses-deno-create-select-deno/expenses-deno-partial-deno-select/expenses-deno-partial-deno-select';
import { ExpensesDenoPartialDenoSelectedPage } from '../pages/income-expenses/expenses-deno-create/expenses-deno-create-select-deno/expenses-deno-partial-deno-selected/expenses-deno-partial-deno-selected';
import { ExpensesDenoCreateSeparatePercetagePage } from '../pages/income-expenses/expenses-deno-create/expenses-deno-create-separate-percetage/expenses-deno-create-separate-percetage';
import { CartaListPage } from '../pages/carta/carta-list/carta-list';
import { CartaCreateSelectTypePage } from '../pages/carta/carta-create/carta-create-select-type/carta-create-select-type';
import { CartaCreateDishProdSelectPage } from '../pages/carta/carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select';
import { CartaPartialDishProdSelectPage } from '../pages/carta/carta-create/carta-create-dish-prod-select/carta-partial-dish-prod-select/carta-partial-dish-prod-select';
import { CartaPartialDishProdSelectedPage } from '../pages/carta/carta-create/carta-create-dish-prod-select/carta-partial-dish-prod-selected/carta-partial-dish-prod-selected';
import { CartaCreateListDetailsPage } from '../pages/carta/carta-create/carta-create-list-details/carta-create-list-details';
import { CartaCreateFinishSectionPage } from '../pages/carta/carta-create/carta-create-finish-section/carta-create-finish-section';
import { CartaCreateCustomizeViewPage } from '../pages/carta/carta-view/carta-create-customize-view';
import { CartaPartialCustomizeEditablePage } from '../pages/carta/carta-view/carta-partial-customize-editable/carta-partial-customize-editable';
import { CartaPartialCustomizeOptionsPage } from '../pages/carta/carta-view/carta-partial-customize-options/carta-partial-customize-options';
import { CartaPageCustomizeTemplatPage } from '../pages/carta/carta-view/carta-partial-customize-options/carta-page-customize-template/carta-page-customize-template';
import { CartaPageCustomizeSeparatorsPage } from '../pages/carta/carta-view/carta-partial-customize-options/carta-page-customize-separators/carta-page-customize-separators';
import { CartaPartialCustomizeViewPage } from '../pages/carta/carta-view/carta-partial-customize-view/carta-partial-customize-view';
import { CartaServices } from '../pages/carta/services';
import { HomePrincipalPage } from '../pages/schools/home-principal/home-principal';
import { TeachersListPage } from '../pages/schools/teachers-list/teachers-list';
import { SchoolServices } from '../pages/schools/services';
import { StudentsListPage } from '../pages/schools/students-list/students-list';
import { StudentsCreatePage } from '../pages/schools/students-create/students-create';
import { TeachersCreatePage } from '../pages/schools/teachers-create/teachers-create';
import { ClassroomsListPage } from '../pages/schools/classrooms-list/classrooms-list';
import { ClassroomsCreateTeachersSelectPage } from '../pages/schools/classrooms-create/classrooms-create-teachers-select/classrooms-create-teachers-select';
import { ClassroomsPartialTeachersSelectPage } from '../pages/schools/classrooms-create/classrooms-create-teachers-select/classrooms-partial-teachers-select/classrooms-partial-teachers-select';
import { ClassroomsPartialTeachersSelectedPage } from '../pages/schools/classrooms-create/classrooms-create-teachers-select/classrooms-partial-teachers-selected/classrooms-partial-teachers-selected';
import { ClassroomsCreateStudentsSelectPage } from '../pages/schools/classrooms-create/classrooms-create-students-select/classrooms-create-students-select';
import { ClassroomsPartialStudentsSelectPage } from '../pages/schools/classrooms-create/classrooms-create-students-select/classrooms-partial-students-select/classrooms-partial-students-select';
import { ClassroomsPartialStudentsSelectedPage } from '../pages/schools/classrooms-create/classrooms-create-students-select/classrooms-partial-students-selected/classrooms-partial-students-selected';
import { FilterPipeTeachers } from '../pages/schools/teachers-list/filter.pipe';
import { FilterPipeStudents } from '../pages/schools/students-list/filter.pipe';
import { FilterPipeClassrooms } from '../pages/schools/classrooms-list/filter.pipe';
import { TeachersViewPage } from '../pages/schools/teachers-view/teachers-view';
import { StudentsViewPage } from '../pages/schools/students-view/students-view';
import { ClassroomsViewPage } from '../pages/schools/classrooms-view/classrooms-view';
import { HomeTeacherPage } from '../pages/schools/home-teacher/home-teacher';
import { ClassroomsStudentsListPage } from '../pages/schools/classrooms-students-list/classrooms-students-list';
import { FilterCartaPipe } from '../pages/carta/filter.pipe';
import { DescriptionLangPage } from '../pages/components/description-lang/description-lang';
import { ProvidersAddSelectElementsPage } from '../pages/providers/providers-add-select-elements/providers-add-select-elements';
import { ProvidersPartialIngredientsSelectPage } from '../pages/providers/providers-add-select-elements/providers-partial-ingredients-select/providers-partial-ingredients-select';
import { ProvidersPartialIngredientsSelectedPage } from '../pages/providers/providers-add-select-elements/providers-partial-ingredients-selected/providers-partial-ingredients-selected';
import { ProvidersPartialProductsSelectPage } from '../pages/providers/providers-add-select-elements/providers-partial-products-select/providers-partial-products-select';
import { ProvidersPartialProductsSelectedPage } from '../pages/providers/providers-add-select-elements/providers-partial-products-selected/providers-partial-products-selected';
import { AddonsServices } from "../pages/addons/services";
import { ConfigurationUsersScreenBlockPage } from '../pages/configuration/configuration-users-screen-block/configuration-users-screen-block';
import { ConfigurationUsersScreenBlockCreatePage } from '../pages/configuration/configuration-users-screen-block/configuration-users-screen-block-create/configuration-users-screen-block-create';
import { BackgroundMode } from '@ionic-native/background-mode';
import { StartScreensPage } from '../pages/components/start-screens/start-screens';
import { ConfigurationLogsPage } from '../pages/configuration/configuration-logs/configuration-logs';
import { FilterPipeLogs } from '../pages/configuration/configuration-logs/filter.pipe';
import { TutorialBox } from '../pages/help/tutorial-box/tutorial-box';
import { TutorialBoxDish } from '../pages/help/tutorial-box/tutorial-box-dish/tutorial-box-dish';
import { TutorialBoxMenu } from '../pages/help/tutorial-box/tutorial-box-menu/tutorial-box-menu';
import { TutorialBoxSale } from '../pages/help/tutorial-box/tutorial-box-sale/tutorial-box-sale';
import { StarPRNT } from '@ionic-native/star-prnt';
import { ConfigurationThermalPrintersPage } from '../pages/configuration/configuration-thermal-printers/configuration-thermal-printers';
import { ConfigurationPrintersStarprntPage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-starprnt/configuration-printers-starprnt';
import { ConfigurationPrintersWizardTypePage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-wizard/configuration-printers-wizard-type/configuration-printers-wizard-type';
import { ConfigurationPrintersNativePage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-native/configuration-printers-native';
import { ConfigurationPrintersWizardListPage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-wizard/configuration-printers-wizard-list/configuration-printers-wizard-list';
import { ConfigurationTicketPrintPage } from '../pages/configuration/configuration-tickets/configuration-ticket-print/configuration-ticket-print';
import { InvoicesTicketPrintPage } from '../pages/invoices/invoices-ticket-print/invoices-ticket-print';

//
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MostSalesElementsComponent } from "../components/analytics/most-sales-elements/most-sales-elements";
import { ConfigurationPrintersPrintservicesPage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-printservices/configuration-printers-printservices';
import { HomeDashboardPage } from '../pages/home/home-dashboard/home-dashboard';
import { HomeDashboardTopSalesPage } from '../pages/home/home-dashboard/home-dashboard-top-sales/home-dashboard-top-sales';
import { HomeDashboardLastSalesPage } from '../pages/home/home-dashboard/home-dashboard-last-sales/home-dashboard-last-sales';
import { HomeDashboardLastTicketsPage } from '../pages/home/home-dashboard/home-dashboard-last-tickets/home-dashboard-last-tickets';
import { HomeDashboardStockListPage } from '../pages/home/home-dashboard/home-dashboard-stock-list/home-dashboard-stock-list';
import { HomeDashboardLastLogsPage } from '../pages/home/home-dashboard/home-dashboard-last-logs/home-dashboard-last-logs';
import { HomeDashboardReservationsPage } from '../pages/home/home-dashboard/home-dashboard-reservations/home-dashboard-reservations';
import { HomeDashboardMinutePage } from '../pages/home/home-dashboard/home-dashboard-minute/home-dashboard-minute';

import { KitchenOrderPrintPage } from '../pages/kitchen/kitchen-order-print/kitchen-order-print';
import { ConfigurationIntegrationsPage } from '../pages/configuration/configuration-integrations/configuration-integrations';
import { VariationsDishSelectorPage } from '../pages/variations/variations-dish-selector/variations-dish-selector';
import { VariationsProductSelectorPage } from '../pages/variations/variations-product-selector/variations-product-selector';
import { ConfigurationPrintersSunmiPage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-sunmi/configuration-printers-sunmi';
import { ImportExcelPage } from '../pages/components/import-excel/import-excel';
import { ImportFinishPage } from "../pages/components/import-excel/import-finish/import-finish";
import { HomeDashboardAddonPro } from '../pages/home/home-dashboard/home-dashboard-addon-pro/home-dashboard-addon-pro';

//TestPopup
import { TakeawayOrderInviteDiscountElementPage } from '../pages/takeaway/takeaway-order-invite-discount-element/takeaway-order-invite-discount-element';
import { TpvTicketInviteDiscountElementPage } from '../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-invite-discount-element/tpv-ticket-invite-discount-element';
import { ConfigurationTipsPage } from '../pages/configuration/configuration-tips/configuration-tips';
import { TipsPage } from '../pages/components/popups/tips/tips';
import { PopupPrintPage } from '../pages/components/popups/popup-print/popup-print';
import { DatetimeLocationPage } from '../pages/components/datetime-location/datetime-location';
import { PopupErrorsPage } from '../pages/components/popups/popup-errors/popup-errors';
import { Network } from '@ionic-native/network';
import { NativeStorage } from '@ionic-native/native-storage';

import { QuillModule } from 'ngx-quill'
import { MenuCreateExtrasPage } from '../pages/menu/menu-create/menu-create-extras/menu-create-extras';
import { MenuPartialExtrasDishesSelectPage } from '../pages/menu/menu-create/menu-create-extras/menu-partial-extras-dishes-select/menu-partial-extras-dishes-select';
import { MenuPartialExtrasDishesSelectedPage } from '../pages/menu/menu-create/menu-create-extras/menu-partial-extras-dishes-selected/menu-partial-extras-dishes-selected';
import { PosDishPage } from '../pages/components/pos/pos-dish/pos-dish';
import { PosFavouritePage } from '../pages/components/pos/pos-favourite/pos-favourite';
import { PosProductPage } from '../pages/components/pos/pos-product/pos-product';
import { PosMenuPage } from '../pages/components/pos/pos-menu/pos-menu';
import { VariationsCreateFavSelectPage } from '../pages/variations/variations-create-fav-select/variations-create-fav-select';
import { VariationsPartialFavSelectPage } from '../pages/variations/variations-create-fav-select/variations-partial-fav-select/variations-partial-fav-select';
import { VariationsPartialFavSelectedPage } from '../pages/variations/variations-create-fav-select/variations-partial-fav-selected/variations-partial-fav-selected';
import { AlegraServices } from '../pages/services/alegraServices';
import { DishCreateObservationsPage } from '../pages/dish/dish-create/dish-create-observations/dish-create-observations';
import { DishViewObservationsPage } from '../pages/dish/dish-view/dish-view-observations/dish-view-observations';
import { ProductCreateObservationsPage } from '../pages/products/product-create/product-create-observations/product-create-observations';
import { ProductViewObservationsPage } from '../pages/products/product-view/product-view-observations/product-view-observations';
import { IngredientCreateObservationsPage } from '../pages/ingredients/ingredient-create/ingredient-create-observations/ingredient-create-observations';
import { IngredientViewObservationsPage } from '../pages/ingredients/ingredient-view/ingredient-view-observations/ingredient-view-observations';
import { ConfigurationPartialRoomsCreateNamePage } from '../pages/configuration/configuration-rooms/configuration-rooms-create/configuration-partial-rooms-create-name/configuration-partial-rooms-create-name';
import { ConfigurationPartialRoomsCreateMapPage } from '../pages/configuration/configuration-rooms/configuration-rooms-create/configuration-partial-rooms-create-map/configuration-partial-rooms-create-map';
import { ConfigurationPartialRoomsCreateListPage } from '../pages/configuration/configuration-rooms/configuration-rooms-create/configuration-partial-rooms-create-list/configuration-partial-rooms-create-list';
import { DishBiPage } from '../components/bi/dish-bi/dish-bi';
import { DishViewPrintLabelPage } from '../pages/dish/dish-view/dish-view-print-label/dish-view-print-label';
import { DishViewLabelPage } from '../pages/dish/dish-view/dish-view-label/dish-view-label';
import { FlagsLangPage } from '../pages/components/flags-lang/flags-lang';
import { ViewNameDescLangPage } from '../pages/components/view-name-desc-lang/view-name-desc-lang';
import { DishPartialNamePage } from '../pages/dish/dish-create/dish-create-name/dish-partial-name/dish-partial-name';
import { TopStockPage } from '../pages/components/top-stock/top-stock';
import { MinMaxListPage } from '../pages/stock/min-max-list/min-max-list';
import { DishPartialDescriptionPage } from '../pages/dish/dish-create/dish-create-name/dish-partial-description/dish-partial-description';
import { ProductCreatePartialNamePage } from '../pages/products/product-create/product-create-partial-name/product-create-partial-name';
import { ProductCreatePartialDescriptionPage } from '../pages/products/product-create/product-create-partial-description/product-create-partial-description';
import { DishCreateNutritionPage } from '../pages/dish/dish-create/dish-create-nutrition/dish-create-nutrition';
import { DishViewNutritionPage } from '../pages/dish/dish-view/dish-view-nutrition/dish-view-nutrition';
import { ProviderFilePage } from '../pages/ads/provider-file/provider-file';
import { ProviderAdsPage } from '../pages/ads/provider-ads/provider-ads';
import { ProviderListSelectPage } from '../pages/ads/provider-list-select/provider-list-select';
import { ProviderNewPage } from '../pages/ads/provider-new/provider-new';
import { ProviderDashboardPage } from '../pages/ads/provider-dashboard/provider-dashboard';
import { ProductsAdsPage } from '../pages/ads/products-ads/products-ads';
import { ProductsStockPage } from '../pages/ads/products-stock/products-stock';
import { AdsServices } from '../pages/ads/services';
import { FilterPipeAds } from '../pages/ads/filter.pipe';
import { QRServices } from '../pages/services/qrServices';
import { KitchenSectionsPage } from '../pages/components/popups/kitchen-sections/kitchen-sections';
import { TakeawayOrderInfoCustomerPage } from '../pages/takeaway/takeaway-order/takeaway-order-info-customer/takeaway-order-info-customer';
import { TopReservationsPage } from '../pages/components/top-reservations/top-reservations';
import { ReservationPendingListPage } from '../pages/reservation/reservation-pending-list/reservation-pending-list';
import { ReservationAcceptedListPage } from '../pages/reservation/reservation-accepted-list/reservation-accepted-list';
import { ReservationDeniedListPage } from '../pages/reservation/reservation-denied-list/reservation-denied-list';
import { DeniedReservationPage } from '../pages/components/popups/denied-reservation/denied-reservation';
import { SearcherCustomersPage } from '../pages/components/searcher-customers/searcher-customers';
import { ConfigurationDeliveriesPage } from '../pages/configuration/configuration-deliveries/configuration-deliveries';
import { ConfigurationDeliveriesCreatePage } from '../pages/configuration/configuration-deliveries/configuration-deliveries-create/configuration-deliveries-create';
import { TakeawayOrderNotesPage } from '../pages/takeaway/takeaway-order/takeaway-order-notes/takeaway-order-notes';
import { PosComboPage } from '../pages/components/pos/pos-combo/pos-combo';
import { PosListElementsPage } from '../pages/components/pos/pos-list-elements/pos-list-elements';
import { ConfigurationIntegrationsPopupPage } from '../pages/configuration/configuration-integrations/configuration-integrations-popup/configuration-integrations-popup';
import { SearchServices } from '../pages/services/searchs';
import { SelectedPersonsPage } from '../pages/components/selected-persons/selected-persons';
import { ReservationManualCreatePage } from '../pages/reservation/reservation-manual-create/reservation-manual-create';
import { ConfigurationPaymentsChargesPage } from '../pages/configuration/configuration-payments-charges/configuration-payments-charges';
import { ConfigurationRestWebPage } from '../pages/configuration/configuration-rest-web/configuration-rest-web';
import { ConfigurationRestWebZipcodePage } from '../pages/configuration/configuration-rest-web/configuration-rest-web-zipcode/configuration-rest-web-zipcode';
import { ConfigurationViewChargePage } from '../pages/configuration/configuration-payments-charges/configuration-view-charge/configuration-view-charge';
import { StockListUpdateInventoryPage } from '../pages/stock/stock-list-update-inventory/stock-list-update-inventory';
import { PosElementPersonPage } from '../pages/components/pos/pos-element-person/pos-element-person';
import { ConfigurationOrdersPage } from '../pages/configuration/configuration-orders/configuration-orders';
import { ConfigurationRestWebSchedulePage } from '../pages/configuration/configuration-rest-web/configuration-rest-web-schedule/configuration-rest-web-schedule';
import { PopupInfoPage } from '../pages/components/popups/popup-info/popup-info';
import { OrdersTableNotesPage } from '../pages/orders/orders-table/orders-table-notes/orders-table-notes';
import { VersionProPage } from '../pages/components/version-pro/version-pro';
import { AddonsUserArrivalPage } from '../pages/addons/addons-user-arrival/addons-user-arrival';
import { AddonsTriggerVersionProPage } from '../pages/addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { MenuCreateSelectTemplatePage } from '../pages/menu/menu-create/menu-create-select-template/menu-create-select-template';
import { MenuTemplateChallengerPage } from '../pages/menu/menu-templates/menu-template-challenger/menu-template-challenger';
import { MenuTemplateCamaroPage } from '../pages/menu/menu-templates/menu-template-camaro/menu-template-camaro';
import { CartaCreateSelectTemplatePage } from '../pages/carta/carta-create/carta-create-select-template/carta-create-select-template';
import { CartaTemplateGladiusPage } from '../pages/carta/carta-templates/carta-template-gladius/carta-template-gladius';
import { CartaTemplateCotaPage } from '../pages/carta/carta-templates/carta-template-cota/carta-template-cota';
import { CartaTemplateTmaxPage } from '../pages/carta/carta-templates/carta-template-tmax/carta-template-tmax';
import { CartaTemplateAeroxPage } from '../pages/carta/carta-templates/carta-template-aerox/carta-template-aerox';
import { CartaTemplateBultacoPage } from '../pages/carta/carta-templates/carta-template-bultaco/carta-template-bultaco';
import { CartaTemplateScoopyPage } from '../pages/carta/carta-templates/carta-template-scoopy/carta-template-scoopy';
import { CustomersCreateInfoPage } from '../pages/customers/customers-create/customers-create-info/customers-create-info';
import { LoginPreviewPage } from '../pages/auth/login-preview/login-preview';
import { AddonsVersionProPage } from '../pages/addons/addons-version-pro/addons-version-pro';
import { AddonsVersionProCancelPage } from '../pages/addons/addons-version-pro-cancel/addons-version-pro-cancel';
import { KitchenOrderSectionsPage } from '../pages/kitchen/kitchen-order-sections/kitchen-order-sections';
import { KitchenOrderTagsPage } from '../pages/kitchen/kitchen-order-tags/kitchen-order-tags';
import { PrinterSunmiAutoPage } from '../pages/printer-sunmi/printer-sunmi-auto/printer-sunmi-auto';
import { PrinterSunmiQueuePage } from '../pages/printer-sunmi/printer-sunmi-queue/printer-sunmi-queue';
import { PrinterSunmiConfPage } from '../pages/printer-sunmi/printer-sunmi-conf/printer-sunmi-conf';
import { PrinterSunmiInfoPage } from '../pages/printer-sunmi/printer-sunmi-info/printer-sunmi-info';
import { MenuTemplateFirebirdPage } from '../pages/menu/menu-templates/menu-template-firebird/menu-template-firebird';
import { CartaTemplateVespinoPage } from '../pages/carta/carta-templates/carta-template-vespino/carta-template-vespino';
import { CartaTemplateJogPage } from '../pages/carta/carta-templates/carta-template-jog/carta-template-jog';
import { CartaTemplateVariantPage } from '../pages/carta/carta-templates/carta-template-variant/carta-template-variant';
import { MenuTemplateMultiplaPage } from '../pages/menu/menu-templates/menu-template-multipla/menu-template-multipla';
import { OrdersTableTpvTicketPrintPage } from '../pages/orders/orders-table/orders-table-tpv-ticket-print/orders-table-tpv-ticket-print';
import { MenuCreatePartialTitlePage } from '../pages/menu/menu-create/menu-create-title/menu-create-partial-title/menu-create-partial-title';
import { CustomersTicketsInvoicesListPage } from '../pages/customers/customers-tickets-invoices-list/customers-tickets-invoices-list';
import { CustomersElementsListPage } from '../pages/customers/customers-elements-list/customers-elements-list';
import { FilterPipeCustomerElementsEaten } from '../pages/customers/customers-elements-list/filter.pipe';
import { ConfigurationVariationAddElementsPage } from '../pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variation-add-elements/configuration-variation-add-elements';
import { ConfigurationVariationsAddElementsSelectPage } from '../pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variation-add-elements/configuration-varitations-add-elements-select/configuration-varitations-add-elements-select';
import { ConfigurationVariationsAddElementsSelectedPage } from '../pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variation-add-elements/configuration-varitations-add-elements-selected/configuration-varitations-add-elements-selected';
import { ComboListPage } from '../pages/combo/combo-list/combo-list';
import { ComboPartialSharePage } from '../pages/combo/combo-list/combo-partial-share/combo-partial-share';
import { ComboPartialRatioPage } from '../pages/combo/combo-list/combo-partial-ratio/combo-partial-ratio';
import { ComboTemplateConorPage } from '../pages/combo/combo-templates/combo-template-conor/combo-template-conor';
import { TopMenuComboPage } from '../pages/components/top-menu-combo/top-menu-combo';
import { ComboCreateTitlePage } from '../pages/combo/combo-create/combo-create-title/combo-create-title';
import { ComboCreatePartialTitlePage } from '../pages/combo/combo-create/combo-create-title/combo-create-partial-title/combo-create-partial-title';
import { ComboCreatePartialDescriptionPage } from '../pages/combo/combo-create/combo-create-title/combo-create-partial-description/combo-create-partial-description';
import { ComboCreatePartialTagsPage } from '../pages/combo/combo-create/combo-create-title/combo-create-partial-tags/combo-create-partial-tags';
import { ComboServices } from '../pages/combo/services';
import { ComboCreateDishSelectPage } from '../pages/combo/combo-create/combo-create-dish-select/combo-create-dish-select';
import { ComboPartialDishesSelectPage } from '../pages/combo/combo-create/combo-create-dish-select/combo-partial-dishes-select/combo-partial-dishes-select';
import { ComboPartialDishesSelectedPage } from '../pages/combo/combo-create/combo-create-dish-select/combo-partial-dishes-selected/combo-partial-dishes-selected';
import { ComboCreateFinishSectionPage } from '../pages/combo/combo-create/combo-create-finish-section/combo-create-finish-section';
import { ComboCreatePricePage } from '../pages/combo/combo-create/combo-create-price/combo-create-price';
import { ComboCreateImagePage } from '../pages/combo/combo-create/combo-create-image/combo-create-image';
import { ComboCreateSelectTemplatePage } from '../pages/combo/combo-create/combo-create-select-template/combo-create-select-template';
import { ComboTemplateBhPage } from '../pages/combo/combo-templates/combo-template-bh/combo-template-bh';
import { PrinterSunmiSectionsPage } from '../pages/printer-sunmi/printer-sunmi-sections/printer-sunmi-sections';
import { PrinterSunmiTagsPage } from '../pages/printer-sunmi/printer-sunmi-tags/printer-sunmi-tags';
import { ComboCreateCustomizeViewPage } from '../pages/combo/combo-view/combo-create-customize-view';
import { TpvTicketChangeTablePage } from '../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-change-table/tpv-ticket-change-table';
import { ConfigurationCloseCashViewPage } from '../pages/configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';
import { CartaTemplateCota25Page } from '../pages/carta/carta-templates/carta-template-cota-25/carta-template-cota-25';
import { CartaTemplateTyphoonPage } from '../pages/carta/carta-templates/carta-template-typhoon/carta-template-typhoon';
import { CartaTemplateOssaPage } from '../pages/carta/carta-templates/carta-template-ossa/carta-template-ossa';
import { MenuTemplateTiguanPage } from '../pages/menu/menu-templates/menu-template-tiguan/menu-template-tiguan';
import { CartaTemplatePuchPage } from '../pages/carta/carta-templates/carta-template-puch/carta-template-puch';
import { CartaTemplateVespaPage } from '../pages/carta/carta-templates/carta-template-vespa/carta-template-vespa';
import { MenuTemplateFordFocusPage } from '../pages/menu/menu-templates/menu-template-ford-focus/menu-template-ford-focus';
import { Device } from '@ionic-native/device';
import { CartaTemplateRd350Page } from '../pages/carta/carta-templates/carta-template-rd350/carta-template-rd350';
import { MenuTemplateAudiPage } from '../pages/menu/menu-templates/menu-template-audi/menu-template-audi';
import { MenuTemplateAudiA1Page } from '../pages/menu/menu-templates/menu-template-audi-a1/menu-template-audi-a1';
import { MenuTemplateMercedesPage } from '../pages/menu/menu-templates/menu-template-mercedes/menu-template-mercedes';
import { CartaTemplateP200Page } from '../pages/carta/carta-templates/carta-template-p200/carta-template-p200';
import { ConfigurationCloseCashViewPrintPage } from '../pages/configuration/configuration-close-cash/configuration-close-cash-view-print/configuration-close-cash-view-print';
import { TakeawayOrdersRecoverPage } from '../pages/takeaway/takeaway-orders/takeaway-orders-recover/takeaway-orders-recover';
import { TakeawayOrdersDeletePage } from '../pages/takeaway/takeaway-orders/takeaway-orders-delete/takeaway-orders-delete';
import { HomeDashboardBillingPage } from '../pages/home/home-dashboard/home-dashboard-billing/home-dashboard-billing';
import { HomeDashboardAlertsPage } from '../pages/home/home-dashboard/home-dashboard-alerts/home-dashboard-alerts';
import { TpvHoraryPage } from '../pages/tpv/tpv-horary/tpv-horary';
import { TakeawayDeliveryFavoritesPage } from '../pages/takeaway/takeaway-delivery-favorites/takeaway-delivery-favorites';
import { TakeawaySelectState } from '../pages/components/popups/takeaway-select-state/takeaway-select-state';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TakeawayOrderInfoIntegrationPage } from '../pages/takeaway/takeaway-order/takeaway-order-info-integration/takeaway-order-info-integration';
import { SelectBetweenDatetime } from '../pages/components/popups/select-between-datetime/select-between-datetime';
import { ConfigurationPrintersNativePrintPage } from '../pages/configuration/configuration-thermal-printers/configuration-printers-native-print/configuration-printers-native-print';
import { AnalyticsServices } from '../pages/services/analyticsServices';
import { AnayliticsMenuComboPage } from '../pages/components/anaylitics-menu-combo/anaylitics-menu-combo';
import { MctPayVerifonePage } from '../pages/mct-pay/mct-pay-verifone/mct-pay-verifone';
import { AnalyticsSalesSalesViewPage } from '../pages/components/analytics/analytics-sales-sales-view/analytics-sales-sales-view';
import { CartaViewSimulatorPage } from '../pages/carta/carta-view/carta-view-simulator/carta-view-simulator';
import { ComboViewSimulatorPage } from '../pages/combo/combo-view/combo-view-simulator/combo-view-simulator';
import { KitchenDeleteOrdersPage } from '../pages/kitchen/kitchen-delete-orders/kitchen-delete-orders';
import { Push } from '@ionic-native/push';
import { NotificationsPage } from '../pages/components/notifications/notifications';
import { NotificationsServices } from '../pages/services/notificationsServices';
import { PopupSelectPayment } from '../pages/components/popups/popup-select-payment/popup-select-payment';
import { PopupSelectDiscount } from '../pages/components/popups/popup-select-discount/popup-select-discount';
import { PrintTicketOrETicket } from '../pages/components/popups/print-ticket-or-eticket/print-ticket-or-eticket';
import { ModalRatings } from '../pages/components/modal-ratings/modal-ratings';
import { ConfigurationTicketsRatingsListPage } from '../pages/configuration/configuration-tickets/configuration-tickets-ratings-list/configuration-tickets-ratings-list';
import { PopupSelectCustomer } from '../pages/components/popups/popup-select-customer/popup-select-customer';
import { TakeawayOldDeleteOrdersPage } from '../pages/takeaway/takeaway-old-delete-orders/takeaway-old-delete-orders';
import { TakeawayOrdersStatePage } from '../pages/takeaway/takeaway-orders/takeaway-select-orders/takeaway-orders-state/takeaway-orders-state';
import { FilterPipeTakeaway } from '../pages/takeaway/takeaway-orders/takeaway-select-orders/filter.pipe';
import { PaymentsType } from '../pages/components/payments_type/payments_type';
import { ConfigurationPaymentMethodsPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-methods';
import { ConfigurationPaymentStripePage } from '../pages/configuration/configuration-payment-methods/configuration-payment-stripe/configuration-payment-stripe';
import { ConfigurationPaymentPaypalPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-paypal/configuration-payment-paypal';
import { ConfigurationPaymentCryptoPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-crypto/configuration-payment-crypto';
import { ConfigurationPaymentVerifonePage } from '../pages/configuration/configuration-payment-methods/configuration-payment-verifone/configuration-payment-verifone';
import { ConfigurationPaymentPayplazaPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-payplaza/configuration-payment-payplaza';
import { PhotoDishPage } from '../pages/components/photo/photo-dish/photo-dish';
import { PhotoProductPage } from '../pages/components/photo/photo-product/photo-product';
import { PhotoIngredientPage } from '../pages/components/photo/photo-ingredient/photo-ingredient';
import { PhotoComboPage } from '../pages/components/photo/photo-combo/photo-combo';
import { Deeplinks } from '@ionic-native/deeplinks';
import { HomeUserBlock } from '../pages/home/home-dashboard/home-user-block/home-user-block';
import { PopupTicketRefund } from '../pages/components/popups/popup-ticket-refund/popup-ticket-refund';
import { ReservationConfig } from '../pages/reservation/reservation-config/reservation-config';
import { ModalExtraInput } from '../pages/components/modal-extra-input/modal-extra-input';
import { ConfigurationDomainsPage } from '../pages/configuration/configuration-domains/configuration-domains';
import { PopupNewAppsPage } from '../pages/components/popups/popup-new-apps/popup-new-apps';
import { CartaTemplateTakeawayPage } from '../pages/carta/carta-templates/carta-template-takeaway/carta-template-takeaway';
import { ConfigurationRestWebEditCartaPage } from '../pages/configuration/configuration-rest-web/configuration-rest-web-edit-carta/configuration-rest-web-edit-carta';
import { AnalyticsPage } from '../pages/analytics/analytics';
import { AnalyticsReportListPage } from '../pages/analytics/components/analytics-report-list/analytics-report-list';
import { AdvancedAnalyticsServices } from '../pages/analytics/advanced-analytics-services';
import { AnalyticsChart } from '../pages/analytics/components/analytics-chart/analytics-chart';
import { SalesSalesPage } from '../pages/analytics/reports/sales-sales/sales-sales';
import { SalesAveragePage } from '../pages/analytics/reports/sales-average/sales-average';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ColorPickerModule } from 'ngx-color-picker';
import { SalesAveragePerDinerPage } from '../pages/analytics/reports/sales-average-per-diner/sales-average-per-diner';
import { SalesSalesPerM2Page } from '../pages/analytics/reports/sales-sales-per-m2/sales-sales-per-m2';
import { SalesZonesPage } from '../pages/analytics/reports/sales-zones/sales-zones';
import { SalesPerHourPage } from '../pages/analytics/reports/sales-per-hours/sales-per-hours';
import { ElementsTopSalesPage } from '../pages/analytics/reports/elements-top-sales/elements-top-sales';
import { ElementsTopSalesCategoryPage } from '../pages/analytics/reports/elements-top-sales-category/elements-top-sales-category';
import { ElementsFoodcostPage } from '../pages/analytics/reports/elements-foodcost/elements-foodcost';
import { ElementsAllergensPage } from '../pages/analytics/reports/elements-allergens/elements-allergens';
import { DeliveryTakeawaySalesPage } from '../pages/analytics/reports/delivery-takeaway-sales/delivery-takeaway-sales';
import { DeliveryTakeawaySalesAvgPage } from '../pages/analytics/reports/delivery-takeaway-sales-avg/delivery-takeaway-sales-avg';
import { DeliveryTakeawayPerDayPage } from '../pages/analytics/reports/delivery-takeaway-per-day/delivery-takeaway-per-day';
import { DeliveryTakeawaySalesTypePage } from '../pages/analytics/reports/delivery-takeaway-sales-type/delivery-takeaway-sales-type';
import { DeliveryTakeawaySalesMapPage } from '../pages/analytics/reports/delivery-takeaway-sales-map/delivery-takeaway-sales-map';
import { DeliveryTakeawaySalesElementsPage } from '../pages/analytics/reports/delivery-takeaway-sales-elements/delivery-takeaway-sales-elements';
import { DeliveryTakeawaySalesCategoriesPage } from '../pages/analytics/reports/delivery-takeaway-sales-categories/delivery-takeaway-sales-categories';
import { WaitersSalesPage } from '../pages/analytics/reports/waiters-sales/waiters-sales';
import { WaitersMovementsPage } from '../pages/analytics/reports/waiters-movements/waiters-movements';
import { PurchasesTotalPage } from '../pages/analytics/reports/purchases-total/purchases-total';
import { PurchasesPerElementPage } from '../pages/analytics/reports/purchases-per-element/purchases-per-element';
import { PurchasesPerCategoryPage } from '../pages/analytics/reports/purchases-per-category/purchases-per-category';
import { PurchasesPerProviderPage } from '../pages/analytics/reports/purchases-per-provider/purchases-per-provider';
import { CustomersTotalPage } from '../pages/analytics/reports/customers-total/customers-total';
import { CustomersNewPage } from '../pages/analytics/reports/customers-new/customers-new';
import { CustomersSalesPage } from '../pages/analytics/reports/customers-sales/customers-sales';
import { CustomersRetentionPage } from '../pages/analytics/reports/customers-retention/customers-retention';
import { StockSummaryPage } from '../pages/analytics/reports/stock-summary/stock-summary';
import { StockValuePage } from '../pages/analytics/reports/stock-value/stock-value';
import { SalesPersonsPerDayPage } from '../pages/analytics/reports/sales-persons-per-day/sales-persons-per-day';
import { SalesPaymentMethodsUsedPage } from '../pages/analytics/reports/sales-payment-methods-used/sales-payment-methods-used';
import { SalesFoodcostPage } from '../pages/analytics/reports/sales-foodcost/sales-foodcost';
import { SalesDiscountsPage } from '../pages/analytics/reports/sales-discounts/sales-discounts';
import { SalesTipsPage } from '../pages/analytics/reports/sales-tips/sales-tips';
import { ReservationsTotalPage } from '../pages/analytics/reports/reservations-total/reservations-total';
import { ReservationsAvgPersonsPerStripePerDayPage } from '../pages/analytics/reports/reservations-avg-persons-per-stripe-per-day/reservations-avg-persons-per-stripe-per-day';
import { ReservationsTopCustomersPage } from '../pages/analytics/reports/reservations-top-customers/reservations-top-customers';
import { KitchenTotalOrdersPage } from '../pages/analytics/reports/kitchen-total-orders/kitchen-total-orders';
import { KitchenAvgTimeCompleteOrderPage } from '../pages/analytics/reports/kitchen-avg-time-complete-order/kitchen-avg-time-complete-order';
import { KitchenDurationToCompleteDishPage } from '../pages/analytics/reports/kitchen-duration-to-complete-dish/kitchen-duration-to-complete-dish';
import { StockElementPage } from '../pages/analytics/reports/stock-element/stock-element';
import { StockMovementsPage } from '../pages/analytics/reports/stock-movements/stock-movements';
import { AnalyticsRealtimePage } from '../pages/analytics/analytics-realtime/analytics-realtime';
import { PopupWaiterReportSales } from '../pages/components/popups/popup-waiter-report-sales/popup-waiter-report-sales';
import { CartaTemplateListPage } from '../pages/carta/carta-templates/carta-template-list/carta-template-list';
import { MenuTemplateListPage } from '../pages/menu/menu-templates/menu-template-list/menu-template-list';
import { MenuTemplateTakeawayPage } from '../pages/menu/menu-templates/menu-template-takeaway/menu-template-takeaway';
import { ComboTemplateListPage } from '../pages/combo/combo-templates/combo-template-list/combo-template-list';
import { ComboTemplateTakeawayPage } from '../pages/combo/combo-templates/combo-template-takeaway/combo-template-takeaway';
import { ComboPartialSectionNamePage } from '../pages/combo/combo-create/combo-create-dish-select/combo-partial-section-name/combo-partial-section-name';
import { ReservationsAnulatedPage } from '../pages/analytics/reports/reservations-anulated/reservations-anulated';
import { SalesPerWeekPage } from '../pages/analytics/reports/sales-per-week/sales-per-week';
import { KitchenTotalOrdersElementsPage } from '../pages/analytics/reports/kitchen-total-orders-elements/kitchen-total-orders-elements';
import { HomeDashboardTkNoPaidPage } from '../pages/home/home-dashboard/home-dashboard-billing/home-dashboard-tk-no-paid/home-dashboard-tk-no-paid';
import { ConfigurationEstablishmentDeletePage } from '../pages/configuration/configuration-establishment/configuration-establishment-delete/configuration-establishment-delete';
import { StockPercentageSalesPerDayPage } from '../pages/analytics/reports/stock-percentage-sales-per-day/stock-percentage-sales-per-day';
import { StockDaysInventoryLeftPage } from '../pages/analytics/reports/stock-days-inventory-left/stock-days-inventory-left';
import { StockCogsPage } from '../pages/analytics/reports/stock-cogs/stock-cogs';
import { StockAbcPage } from '../pages/analytics/reports/stock-abc/stock-abc';
import { TutorialDishesPage } from '../pages/help/tutorials/tutorial-dishes/tutorial-dishes';
import { ConfigurationPuduRobotsPage } from '../pages/configuration/configuration-pudu-robots/configuration-pudu-robots';
import { TutorialStockPage } from '../pages/help/tutorials/tutorial-stock/tutorial-stock';
import { TutorialMenusCombosPage } from '../pages/help/tutorials/tutorial-menus-combos/tutorial-menus-combos';
import { TutorialCartaPage } from '../pages/help/tutorials/tutorial-carta/tutorial-carta';
import { TutorialSalesPage } from '../pages/help/tutorials/tutorial-sales/tutorial-sales';
import { TutorialIncomeExpensesPage } from '../pages/help/tutorials/tutorial-income-expenses/tutorial-income-expenses';
import { TutorialPedidosPage } from '../pages/help/tutorials/tutorial-pedidos/tutorial-pedidos';
import { TutorialReservasPage } from '../pages/help/tutorials/tutorial-reservas/tutorial-reservas';
import { TutorialInformesPage } from '../pages/help/tutorials/tutorial-informes/tutorial-informes';
import { TutorialOrderPage } from '../pages/help/tutorials/tutorial-order/tutorial-order';
import { TutorialTpvPage } from '../pages/help/tutorials/tutorial-tpv/tutorial-tpv';
import { TutorialKitchenPage } from '../pages/help/tutorials/tutorial-kitchen/tutorial-kitchen';
import { AddonsRealTimePage } from '../pages/addons/addons-real-time/addons-real-time';
import { ProductViewAddStockPage } from '../pages/products/product-view/product-view-add-stock/product-view-add-stock';
import { ProductCreateWfoodcostAddStockPage } from '../pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-add-stock/product-create-wfoodcost-add-stock';
import { IngredientAddStockPage } from '../pages/ingredients/ingredient-create/ingredient-add-stock/ingredient-add-stock';
import { StockCostEvolutionPage } from '../pages/analytics/reports/stock-cost-evolution/stock-cost-evolution';
import { HomeDashboardFreePage } from '../pages/home/home-dashboard-free/home-dashboard-free';
import { RegisterPage } from '../pages/auth/register/register';
import { SetupInital3Page } from '../pages/setup/setup-initial-3/setup-initial-3';
import { InvoicesCreateSelectTicketsPage } from '../pages/invoices/invoices-create/invoices-create-select-tickets/invoices-create-select-tickets';
import { ProductionOrderPage } from '../pages/analytics/reports/production-order/production-order';
import { PopupTicketStripeRefund } from '../pages/components/popups/popup-ticket-stripe-refund/popup-ticket-stripe-refund';
import { TicketsListArrosseriaPage } from '../pages/custom/tickets-list-arrosseria/tickets-list-arrosseria';
import { CustomServices } from '../pages/custom/services';
import { PriceCostPage } from '../pages/components/price-cost/price-cost';
import { SelectDateTkPickupDay } from '../pages/components/popups/select-date-tk-pickup-day/select-date-tk-pickup-day';
import { SetupInital4Page } from '../pages/setup/setup-initial-4/setup-initial-4';
import { PopupTableWithTakeaway } from '../pages/components/popups/popup-table-with-takeaway/popup-table-with-takeaway';
import { SearcherRoomsTablesPage } from '../pages/components/searcher-rooms-tables/searcher-rooms-tables';
import { SearchReservationsServices } from '../pages/services/searchsReservation';
import { TpvTicketSelectedListTicketPrintIndvPage } from '../pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-list-ticket-print-indv/tpv-ticket-selected-list-ticket-print-indv';
import { CartaMenuViewPage } from '../pages/cartas-menus/carta-menu-view/carta-menu-view';
import { CartasMenusListPage } from '../pages/cartas-menus/cartas-menus-list/cartas-menus-list';
import { CartaMenuServices } from '../pages/cartas-menus/services';
import { ComponentCartaViewPage } from '../pages/cartas-menus/carta-menu-view/component-carta-view/component-carta-view';
import { ShareXxssPage } from '../pages/components/share-xxss/share-xxss';
import { CompCreateDishPage } from '../pages/components/popups/create-dish/create-dish';
import { PopupFinishCreateElementPage } from '../pages/components/popups/popup-finish-create-element/popup-finish-create-element';
import { CartaEditNamePage } from '../pages/components/popups/carta-edit-name/carta-edit-name';
import { ComponentMenuViewPage } from '../pages/cartas-menus/carta-menu-view/component-menu-view/component-menu-view';
import { MenuEditNamePage } from '../pages/components/popups/menu-edit-name/menu-edit-name';
import { ComponentComboViewPage } from '../pages/cartas-menus/carta-menu-view/component-combo-view/component-combo-view';
import { ComboEditNamePage } from '../pages/components/popups/combo-edit-name/combo-edit-name';
import { HomeCartasMenusPage } from '../pages/home/home-dashboard/home-cards/home-cartas-menus/home-cartas-menus';
import { HomeVersionPage } from '../pages/home/home-dashboard/home-cards/home-version/home-version';
import { ReservationConfigCamps } from '../pages/reservation/reservation-config/reservation-config-camps/reservation-config-camps';
import { ReservationConfigHorary } from '../pages/reservation/reservation-config/reservation-config-horary/reservation-config-horary';
import { ReservationCalendarConfigPage } from '../pages/reservation/reservation-calendar/reservation-calendar-config/reservation-calendar-config';
import { CompCreateReservationPage } from '../pages/components/popups/create-reservation/create-reservation';
import { ReservationCalendarDayViewPage } from '../pages/reservation/reservation-calendar/reservation-calendar-day-view/reservation-calendar-day-view';
import { EmailServices } from '../pages/services/emailServices';
import { HomeReservationsPage } from '../pages/home/home-dashboard/home-cards/home-reservations/home-reservations';
import { ArticlesListPage } from '../pages/articles/articles-list/articles-list';
import { ArticlesServices } from '../pages/articles/services';
import { ArticleViewPage } from '../pages/articles/articles-view/article-view';
import { ArticleViewPhotoPage } from '../pages/articles/articles-view/article-view-photo/article-view-photo';
import { ArticleViewPricePage } from '../pages/articles/articles-view/article-view-price/article-view-price';
import { ArticleViewOthersPage } from '../pages/articles/articles-view/article-view-others/article-view-others';
import { ArticleViewFoodcostPage } from '../pages/articles/articles-view/article-view-foodcost/article-view-foodcost';
import { ArticleViewPreparationPage } from '../pages/articles/articles-view/article-view-preparation/article-view-preparation';
import { ArticleViewNutritionPage } from '../pages/articles/articles-view/article-view-nutrition/article-view-nutrition';
import { ArticleViewObservationsPage } from '../pages/articles/articles-view/article-view-observations/article-view-observations';
import { ArticleViewStockPage } from '../pages/articles/articles-view/article-view-stock/article-view-stock';
import { ArticleViewProvidersPage } from '../pages/articles/articles-view/article-view-providers/article-view-providers';
import { ArticleViewAnalyticsPage } from '../pages/articles/articles-view/article-view-analytics/article-view-analytics';
import { ArticleViewColorsPage } from '../pages/articles/articles-view/article-view-colors/article-view-colors';
import { ArticleViewVariationsFavsPage } from '../pages/articles/articles-view/article-view-variations-favs/article-view-variations-favs';
import { ArticlesCreateTypePage } from '../pages/articles/articles-create/articles-create-type/articles-create-type';
import { CompCreateIngredientPage } from '../pages/components/popups/create-ingredient/create-ingredient';
import { ArticlesUpdatePricesPage } from '../pages/articles/articles-update-prices/articles-update-prices';
import { DeliberyNoteCreateTypePage } from '../pages/delibery_note/delibery-note-create/delibery-note-create-type/delibery-note-create-type';
import { DeliberyNoteCreateFotoPage } from '../pages/delibery_note/delibery-note-create/delibery-note-create-foto/delibery-note-create-foto';
import { PhotoAlbaranPage } from '../pages/components/photo/photo-albaran/photo-albaran';
import { DeliberyNoteResultFotoIa } from '../pages/delibery_note/delibery-note-create/delibery-note-result-foto-ia/delibery-note-result-foto-ia';
import { DeliberyNoteProcessFotoIa } from '../pages/delibery_note/delibery-note-create/delibery-note-process-foto-ia/delibery-note-process-foto-ia';
import { OdsViewPage } from '../pages/ods/ods-view/ods-view';
import { OdsListViewPage } from '../pages/ods/ods-view/ods-list-view/ods-list-view';
import { OdsConfigurationViewPage } from '../pages/ods/ods-view/ods-configuration-view/ods-configuration-view';
import { OdsServices } from '../pages/ods/services';
import { CompCreateTakeawayPage } from '../pages/components/popups/create-takeaway/create-takeaway';
import { OdsConfigHoraryPage } from '../pages/ods/ods-config/ods-config-horary/ods-config-horary';
import { OdsConfigShipmentPage } from '../pages/ods/ods-config/ods-config-shipment/ods-config-shipment';
import { OdsConfigMenuPage } from '../pages/ods/ods-config/ods-config-menu/ods-config-menu';
import { OdsConfigCustomizePage } from '../pages/ods/ods-config/ods-config-customize/ods-config-customize';
import { ConfigurationPaymentRedsysPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-redsys/configuration-payment-redsys';
import { ConfigurationPaymentRedsysBizumPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-redsys-bizum/configuration-payment-redsys-bizum';
import { OdsConfigMenuCreatePage } from '../pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create';
import { OdsConfigMenuCreateSelectPage } from '../pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create-select/ods-config-menu-create-select';
import { OdsConfigMenuCreateSelectedPage } from '../pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create-selected/ods-config-menu-create-selected';
import { OdsConfigMenuCreateFinishPage } from '../pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create-finish/ods-config-menu-create-finish';
import { OdsConfigActiveElementsPage } from '../pages/ods/ods-config/ods-config-active-elements/ods-config-active-elements';
import { ConfigurationPaymentTakeawayPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-takeaway/configuration-payment-takeaway';
import { OdsOrderInfoTicketPrintPage } from '../pages/ods/ods-view/ods-order-info-ticket-print/ods-order-info-ticket-print';
import { OdsConfigModifyElementsPage } from '../pages/ods/ods-config/ods-config-modify-elements/ods-config-modify-elements';
import { HomeOdsPage } from '../pages/home/home-dashboard/home-cards/home-ods/home-ods';
import { HomePosPage } from '../pages/home/home-dashboard/home-cards/home-pos/home-pos';
import { IngredientViewProvidersPage } from '../pages/ingredients/ingredient-view/ingredient-view-providers/ingredient-view-providers';
import { CompCreateProviderPage } from '../pages/components/popups/create-provider/create-provider';
import { IngredientViewOthersPage } from '../pages/ingredients/ingredient-view/ingredient-view-others/ingredient-view-others';
import { IngredientCreateFoodcostPricePage } from '../pages/ingredients/ingredient-create/ingredient-create-foodcost-price/ingredient-create-foodcost-price';
import { IngredientCreateImagePage } from '../pages/ingredients/ingredient-create/ingredient-create-image/ingredient-create-image';
import { TpvPanelPage } from '../pages/tpv/tpv-panel/tpv-panel';
import { HomeArticlesPage } from '../pages/home/home-dashboard/home-cards/home-articles/home-articles';
import { CompCreateDeliveryPage } from '../pages/components/popups/create-delivery/create-delivery';
import { CompCreateProductPage } from '../pages/components/popups/create-product/create-product';
import { AIServices } from '../pages/services/aiServices';
import { ConfigurationCloseCashCreate } from '../pages/configuration/configuration-close-cash/configuration-close-cash-create/configuration-close-cash-create';
import { IngredientViewLabelPage } from '../pages/ingredients/ingredient-view/ingredient-view-label/ingredient-view-label';
import { ConfigurationCloseCashList } from '../pages/configuration/configuration-close-cash/configuration-close-cash-list/configuration-close-cash-list';
import { OurPlansPage } from '../pages/components/our-plans/our-plans';
import { HomeImcomeExpensesPage } from '../pages/home/home-dashboard/home-cards/home-imcome-expenses/home-imcome-expenses';
import { CompCreateTablePage } from '../pages/components/popups/create-table/create-table';
import { CompCreateRoomPage } from '../pages/components/popups/create-room/create-room';
import { OdsConfigPaymentsPage } from '../pages/ods/ods-config/ods-config-payments/ods-config-payments';
import { ConfigurationPaymentsGetnetPage } from '../pages/configuration/configuration-payment-methods/configuration-payments-getnet/configuration-payments-getnet';
import { ConfigurationPaymentGetnetTerminalPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-getnet-terminal/configuration-payment-getnet-terminal';
import { ConfigurationPaymentGetnetTopPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-getnet-top/configuration-payment-getnet-top';
import { ConfigurationIntegrationUberDirectPage } from '../pages/configuration/configuration-integrations/configuration-integration-uberdirect/configuration-integration-uberdirect';
import { ConfigurationCloseCashViewPrintResumenPage } from '../pages/configuration/configuration-close-cash/configuration-close-cash-view-print-resumen/configuration-close-cash-view-print-resumen';
import { ConfigurationSecondDisplaImagesPage } from '../pages/configuration/configuration-second-display-images/configuration-second-display-images';
import { ImportSalesPage } from '../pages/components/import-excel/import-sales/import-sales';
import { ArticleViewComplementsPage } from '../pages/articles/articles-view/article-view-complements/article-view-complements';
import { ConfigurationComplementsCreateListPage } from '../pages/configuration/configuration-complements/configuration-complements-create/configuration-complements-create-list/configuration-complements-create-list';
import { ConfigurationComplementsPage } from '../pages/configuration/configuration-complements/configuration-complements';
import { ComplementsPartialSelectPage } from '../pages/complements/complements-partial-select/complements-partial-select';
import { ComplementsPartialSelectedPage } from '../pages/complements/complements-partial-selected/complements-partial-selected';
import { ComplementsCreateDishSelectPage } from '../pages/complements/complements-partial-select/complements-create-dish-select/complements-create-dish-select';
import { ComplementsPartialDishesSelectPage } from '../pages/complements/complements-partial-select/complements-create-dish-select/complements-partial-dishes-select/complements-partial-dishes-select';
import { ComplementsPartialDishesSelectedPage } from '../pages/complements/complements-partial-select/complements-create-dish-select/complements-partial-dishes-selected/complements-partial-dishes-selected';
import { ComplementsPartialSectionNamePage } from '../pages/complements/complements-partial-select/complements-create-dish-select/complements-partial-section-name/complements-partial-section-name';
import { ConfigurationSocialPage } from '../pages/configuration/configuration-social/configuration-social';
import { ConfigurationPaymentsComerciaGlobalPayPage } from '../pages/configuration/configuration-payment-methods/configuration-payments-comerciaglobalpay/configuration-payments-comerciaglobalpay';
import { ConfigurationPaymentComerciaGlobalPayTopPage } from '../pages/configuration/configuration-payment-methods/configuration-payment-comerciaglobalpay-top/configuration-payment-comerciaglobalpay-top';
import { ConfigurationIntegrationGlovoPage } from '../pages/configuration/configuration-integrations/configuration-integration-glovo/configuration-integration-glovo';
import { ComponentsPopupsInviteFormModalComponent } from '../components/components-popups-invite-form-modal/components-popups-invite-form-modal';
import { ConfigurationAdvancedLogsPage } from '../pages/configuration/configuration-advanced-logs/configuration-advanced-logs';

@NgModule({
    declarations: [
        MyApp,
        HomePage,
        HeaderPage,
        HeaderSchoolPage,
        SideMenuPage,
        SideMenuPageConfig,
        AllergensPage,
        PartialPageTitlePage,
        UploadImagePage,
        IngredientsMeasurementComponent,
        ComponentsPopupsInviteFormModalComponent,
        TagsPage,
        FilterPipe,
        FilterPipeIngredients,
        FilterPipeProduct,
        IngredientsSelectPipe,
        ProdingsSelectPipe,
        FilterPipeDeliberyNote,
        FilterPipeProvider,
        FilterPipeIncomes,
        FilterPipeExpenses,
        FilterPipeAds,
        FilterPipeTicketOpen,
        FilterPipeTicketClosed,
        FilterPipeCloseCash,
        FilterPipeVariations,
        FilterPipeComplements,
        FilterPipeCustomer,
        FilterPipeProviderOrder,
        LoginPage,
        DishListPage,
        DishCreateNamePage,
        DishPartialTagsPage,
        DishTablePage,
        DishCreateAllergensPage,
        DishPartialAllergensPage,
        DishPartialIndicatorsPage,
        DishCreateImagePage,
        DishCreateFinishPage,
        DishViewPage,
        DishViewNamePage,
        DishViewTopPage,
        DishViewTagsPage,
        DishViewAllergensPage,
        DishViewListPage,
        DishViewPreparationPage,
        DishViewPhotoPage,
        DishViewGraphicsPage,
        DishFoodcostPersonsPage,
        DishIngredientsSelectPage,
        DishPartialIngredientsSelectPage,
        DishPartialIngredientsSelectedPage,
        DishIngredientsQuantityPage,
        DishPreparationPage,
        DishCreatePricePage,
        DishCreateObservationsPage,
        DishViewObservationsPage,
        MenuListPage,
        MenuPartialRatioPage,
        MenuPartialSharePage,
        MenuCreateSelectTypePage,
        MenuCreateTitlePage,
        MenuCreateDishSelectPage,
        MenuPartialDishesSelectPage,
        MenuPartialDishesSelectedPage,
        MenuCreatePricenextrasPage,
        MenuCreateCustomizeViewPage,
        MenuPartialCustomizeOptionsPage,
        MenuPartialCustomizeViewPage,
        MenuPartialCustomizeEditablePage,
        MenuPageCustomizeTemplatPage,
        MenuPageCustomizeSeparatorsPage,
        MenuXxssPage,
        MenuCreateExtrasPage,
        MenuPartialExtrasDishesSelectPage,
        MenuPartialExtrasDishesSelectedPage,
        FilterMenuPipe,
        MenuDishPipe,
        IngredientListPage,
        IngredientCreateInfoPage,
        IngredientCreateStockPage,
        IngredientPartialTagsPage,
        IngredientCreateAllergensPage,
        IngredientPartialAllergensPage,
        IngredientPartialIndicatorsPage,
        IngredientCreateSelectProviderPage,
        IngredientPartialProviderSelectPage,
        IngredientPartialProviderSelectedPage,
        IngredientCreateProviderPricePage,
        IngredientCompCreateInfoPage,
        IngredientCompPartialTagsPage,
        IngredientCompCreateSelectIngPage,
        IngredientCompPartialIngSelectPage,
        IngredientCompPartialIngSelectedPage,
        IngredientCompQuantityCostPage,
        IngredientCompCreateStock,
        IngredientViewPage,
        IngredientViewNamePage,
        IngredientViewTagsPage,
        IngredientViewProvidersPage,
        IngredientViewAllergensPage,
        IngredientViewGraphicsPage,
        IngredientViewFoodcostPage,
        IngredientViewStockPage,
        IngredientCompCreatePreparationPage,
        IngredientCompCreateImagePage,
        IngredientViewPreparationPage,
        IngredientViewPhotoPage,
        IngredientCreateSelectType,
        IngredientCreateObservationsPage,
        IngredientViewObservationsPage,
        ProvidersSelectPipe,
        ProductListPage,
        ProductCreateSelectTypePage,
        ProductCreateWfoodcostInfoPage,
        ProductCreateWfoodcostStockPage,
        ProductPartialWfoodcostTagsPage,
        ProductCreateWfoodcostAllergensPage,
        ProductPartialWfoodcostAllergensPage,
        ProductPartialWfoodcostIndicatorsPage,
        ProductCreateWfoodcostSelectProviderPage,
        ProductPartialWfoodcostProviderSelectPage,
        ProductPartialWfoodcostProviderSelectedPage,
        ProductCreateWfoodcostProviderPricePage,
        ProductCreateWfoodcostImagePage,
        ProductCreateWfoodcostPricePage,
        ProductCreateFoodcostInfoPage,
        ProductPartialFoodcostTagsPage,
        ProductCreateFoodcostSelectIngPage,
        ProductPartialFoodcostIngSelectedPage,
        ProductPartialFoodcostIngSelectPage,
        ProductCreateFoodcostQuantityCostPage,
        ProductCreateFoodcostPreparationPage,
        ProductCreateFoodcostImagePage,
        ProductCreateFoodcostPricePage,
        ProductViewPage,
        ProductViewNamePage,
        ProductViewStockPage,
        ProductViewTopPage,
        ProductViewAllergensPage,
        ProductViewTagsPage,
        ProductViewListPage,
        ProductViewPreparationPage,
        ProductViewPhotoPage,
        ProductViewGraphicsPage,
        ProductCreateObservationsPage,
        ProductViewObservationsPage,
        ReservationCalendarPage,
        ReservationDayPage,
        ReservationCreatePage,
        ReservationLoaderPage,
        TpvRoomPage,
        TpvRoomMenuPage,
        TpvSelectRoomPage,
        TpvTicketPage,
        TpvTicketMenuPage,
        TpvTicketSelectPage,
        TpvTicketSelectedPage,
        TpvLoaderPage,
        StockListPage,
        TpvTicketSelectedListTicketPage,
        TpvTicketSelectedPersonsPage,
        TpvKeyboardExportableComponent,
        TpvTicketSelectedListTicketPrintPage,
        TpvTicketSelectedCashPage,
        TpvCashInoutCreatePage,
        ConfigurationPage,
        ConfigurationRoomsPage,
        ConfigurationRoomsCreatePage,
        ConfigurationRoomsCreateTablePage,
        ConfigurationEstablishmentCreatePage,
        ConfigurationPasswordPage,
        ConfigurationUsersPage,
        ConfigurationUsersCreatePage,
        ConfigurationTicketsPage,
        ConfigurationTicketsCreatePage,
        ConfigurationTicketsListPage,
        ConfigurationCashsPage,
        ConfigurationCashsCreatePage,
        ConfigurationVariationsPage,
        ConfigurationVariationCreateSelectTypePage,
        ConfigurationVariationCreateListPage,
        ConfigurationVariationsCreateInfoPage,
        ConfigurationComplementsPage,
        ConfigurationComplementsCreateListPage,
        ConfigurationSocialPage,
        EscapeHtmlPipe,
        TpvTicketSelectedPayPage,
        TpvTicketSelectedPayIndvPage,
        StockProviderListPage,
        DeliberyNoteListPage,
        DeliberyNoteCreateSelectProviderPage,
        DeliberyNoteCreateSelectIngprodPage,
        DeliberyNoteCreatePartialIngprodSelectPage,
        DeliberyNoteCreatePartialIngprodSelectedPage,
        DeliberyNoteCreateIngprodPricePage,
        DeliberyNoteViewPage,
        DeliberyNoteViewInfoPage,
        DeliberyNoteViewListPage,
        IncomeExpensesListPage,
        IncomeCreateDataPage,
        ExpensesCreateDataPage,
        ProvidersCreateDataPage,
        KitchenPage,
        SuperPage,
        PasswordRecoveryPage,
        SetupPage,
        SetupInital2Page,
        MenuPartialCustomizeViewA5Page,
        HiddenScreenPage,
        CustomersListPage,
        CustomersCreateDataPage,
        InvoicesCreateSelectClientPage,
        InvoicesListPage,
        InvoicesViewPage,
        KitchenHistoryPage,
        ConfigurationImagesPage,
        IngredientsSelectPipe,
        IngredientsMeasurementComponent,
        TpvKeyboardExportableComponent,
        FinishProcessPage,
        HelpBottomPage,
        HelpPage,
        DishTutorialSlidePage,
        MenuTutorialSlidePage,
        OrdersLoaderPage,
        OrdersRoomPage,
        OrdersSelectRoomPage,
        OrdersSelectRoomMenuPage,
        OrdersTablePage,
        OrdersTableInfoPage,
        OrdersTableListPage,
        OrdersTableButtonsPage,
        OrdersSelectPage,
        OrdersSelectSelectPage,
        OrdersSelectSelectPage,
        OrdersSelectMenuPage,
        OrdersSelectSelectedPage,
        OrdersSelectSelectedListPage,
        OrdersUpDelPage,
        OrdersSelectSelectedPersonsPage,
        OrdersKeyboardExportableComponent,
        OrdersPositionsPage,
        OrdersTableInfoPrintPage,
        IngredientTutorialSlidePage,
        ProductTutorialSlidePage,
        TpvTutorialSlidePage,
        ReservationTutorialSlidePage,
        StockTutorialSlidePage,
        InexpTutorialSlidePage,
        ConfigurationTutorialSlidePage,
        AddonsTutorialSlidePage,
        DashboardTutorialSlidePage,
        NameLangPage,
        TakeawayLoaderPage,
        TakeawayOrdersPage,
        TakeawayOrdersMenuPage,
        TakeawaySelectOrdersPage,
        TakeawayCreateSelectCustomerPage,
        TakeawayOrderPage,
        TakeawayOrderButtonsPage,
        TakeawayOrderInfoPage,
        TakeawayOrderInfoPrintPage,
        TakeawayOrderListPage,
        TakeawayOrderSelectPage,
        TakeawayOrderSelectSelectPage,
        TakeawayOrderSelectSelectPage,
        TakeawayOrderSelectMenuPage,
        TakeawayOrderSelectSelectedPage,
        TakeawayOrderSelectSelectedListPage,
        TakeawayOrderUpDelPage,
        TakeawayOrderPayPage,
        TakeawayOrderInfoTicketPrintPage,
        BlockScreenPage,
        TpvTicketShowListDetailsPage,
        TakeawayOrderSelectSelectedPersonsPage,
        MultiPage,
        FilterRestaurantsPipe,
        MenuCreateFinishSectionPage,
        AlertMessagePage,
        WeatherPage,
        SalesListPage,
        FilterPipeInvoices,
        ProgressBarPage,
        ProviderOrderCartPage,
        ProviderOrderAddPage,
        ProviderOrderAddDishPage,
        SalesAnalyticsPage,
        ProviderOrderListPage,
        ProviderOrderViewPage,
        TpvTicketSelectElementPage,
        TpvTicketInviteDiscountElementPage,
        TpvTicketDiscountRestaurantticketPage,
        TakeawayOrderInviteDiscountElementPage,
        TakeawayOrderDiscountRestaurantticketPage,
        ExpensesDenoCreateDataPage,
        ExpensesDenoCreateSelectDenoPage,
        ExpensesDenoPartialDenoSelectPage,
        ExpensesDenoPartialDenoSelectedPage,
        ExpensesDenoCreateSeparatePercetagePage,
        CartaListPage,
        CartaCreateSelectTypePage,
        CartaCreateDishProdSelectPage,
        CartaPartialDishProdSelectPage,
        CartaPartialDishProdSelectedPage,
        CartaCreateListDetailsPage,
        CartaCreateFinishSectionPage,
        CartaCreateCustomizeViewPage,
        CartaPartialCustomizeEditablePage,
        CartaPartialCustomizeOptionsPage,
        CartaPageCustomizeTemplatPage,
        CartaPageCustomizeSeparatorsPage,
        CartaPartialCustomizeViewPage,
        FilterCartaPipe,
        HomePrincipalPage,
        TeachersListPage,
        TeachersCreatePage,
        StudentsCreatePage,
        StudentsListPage,
        ClassroomsListPage,
        ClassroomsCreateTeachersSelectPage,
        ClassroomsPartialTeachersSelectPage,
        ClassroomsPartialTeachersSelectedPage,
        ClassroomsCreateStudentsSelectPage,
        ClassroomsPartialStudentsSelectPage,
        ClassroomsPartialStudentsSelectedPage,
        FilterPipeTeachers,
        FilterPipeStudents,
        FilterPipeClassrooms,
        TeachersViewPage,
        StudentsViewPage,
        ClassroomsViewPage,
        HomeTeacherPage,
        ClassroomsStudentsListPage,
        DescriptionLangPage,
        ProvidersAddSelectElementsPage,
        ProvidersPartialIngredientsSelectPage,
        ProvidersPartialIngredientsSelectedPage,
        ProvidersPartialProductsSelectPage,
        ProvidersPartialProductsSelectedPage,
        VariationsDishSelectorPage,
        ConfigurationUsersScreenBlockPage,
        ConfigurationUsersScreenBlockCreatePage,
        StartScreensPage,
        ConfigurationLogsPage,
        FilterPipeLogs,
        TutorialBox,
        TutorialBoxDish,
        TutorialBoxMenu,
        TutorialBoxSale,
        ConfigurationThermalPrintersPage,
        ConfigurationPrintersStarprntPage,
        ConfigurationPrintersNativePage,
        ConfigurationPrintersWizardTypePage,
        ConfigurationPrintersWizardListPage,
        ConfigurationTicketPrintPage,
        InvoicesTicketPrintPage,
        ConfigurationPrintersPrintservicesPage,
        MostSalesElementsComponent,
        HomeDashboardPage,
        HomeDashboardTopSalesPage,
        HomeDashboardLastSalesPage,
        HomeDashboardLastTicketsPage,
        HomeDashboardStockListPage,
        HomeDashboardLastLogsPage,
        HomeDashboardReservationsPage,
        HomeDashboardMinutePage,
        HomeDashboardAddonPro,
        KitchenOrderPrintPage,
        ConfigurationIntegrationsPage,
        StaticAlertPage,
        StaticsUpdatePage,
        VariationsProductSelectorPage,
        ConfigurationPrintersSunmiPage,
        ImportExcelPage,
        ImportFinishPage,
        ConfigurationTipsPage,
        TipsPage,
        PopupPrintPage,
        DatetimeLocationPage,
        PopupErrorsPage,
        DishViewPrintLabelPage,
        DishViewLabelPage,
        PosDishPage,
        PosProductPage,
        PosMenuPage,
        PosFavouritePage,
        VariationsCreateFavSelectPage,
        VariationsPartialFavSelectPage,
        VariationsPartialFavSelectedPage,
        ComplementsCreateSelectPage,
        ComplementsPartialSelectPage,
        ComplementsPartialSelectedPage,
        DishBiPage,
        ConfigurationPartialRoomsCreateNamePage,
        ConfigurationPartialRoomsCreateMapPage,
        ConfigurationPartialRoomsCreateListPage,
        FlagsLangPage,
        ViewNameDescLangPage,
        DishPartialNamePage,
        DishPartialDescriptionPage,
        ProductCreatePartialNamePage,
        ProductCreatePartialDescriptionPage,
        DishCreateNutritionPage,
        DishViewNutritionPage,
        TopStockPage,
        MinMaxListPage,
        ProviderFilePage,
        ProviderAdsPage,
        ProviderListSelectPage,
        ProviderNewPage,
        ProviderDashboardPage,
        ProductsAdsPage,
        ProductsStockPage,
        KitchenSectionsPage,
        TakeawayOrderInfoCustomerPage,
        TopReservationsPage,
        ReservationPendingListPage,
        ReservationAcceptedListPage,
        ReservationDeniedListPage,
        DeniedReservationPage,
        SearcherCustomersPage,
        ConfigurationDeliveriesPage,
        ConfigurationDeliveriesCreatePage,
        TakeawayOrderNotesPage,
        PosComboPage,
        PosListElementsPage,
        ConfigurationIntegrationsPopupPage,
        ReservationManualCreatePage,
        SelectedPersonsPage,
        ConfigurationPaymentsChargesPage,
        ConfigurationRestWebPage,
        ConfigurationRestWebZipcodePage,
        ConfigurationViewChargePage,
        StockListUpdateInventoryPage,
        PosElementPersonPage,
        ConfigurationOrdersPage,
        ConfigurationRestWebSchedulePage,
        PopupInfoPage,
        OrdersTableNotesPage,
        VersionProPage,
        AddonsUserArrivalPage,
        AddonsTriggerVersionProPage,
        MenuCreateSelectTemplatePage,
        MenuTemplateCamaroPage,
        MenuTemplateChallengerPage,
        MenuTemplateTiguanPage,
        MenuTemplateFordFocusPage,
        MenuTemplateAudiPage,
        MenuTemplateAudiA1Page,
        MenuTemplateMercedesPage,
        CartaCreateSelectTemplatePage,
        CartaTemplateGladiusPage,
        CartaTemplateCotaPage,
        CartaTemplateCota25Page,
        CartaTemplateTmaxPage,
        CartaTemplateAeroxPage,
        CartaTemplateBultacoPage,
        CartaTemplateScoopyPage,
        CartaTemplateTyphoonPage,
        CartaTemplateOssaPage,
        CartaTemplatePuchPage,
        CartaTemplateVespaPage,
        CartaTemplateRd350Page,
        CartaTemplateP200Page,
        CustomersCreateInfoPage,
        LoginPreviewPage,
        AddonsVersionProPage,
        AddonsVersionProCancelPage,
        KitchenOrderSectionsPage,
        KitchenOrderTagsPage,
        PrinterSunmiAutoPage,
        PrinterSunmiQueuePage,
        PrinterSunmiConfPage,
        PrinterSunmiInfoPage,
        MenuTemplateFirebirdPage,
        CartaTemplateVespinoPage,
        CartaTemplateJogPage,
        CartaTemplateVariantPage,
        MenuTemplateMultiplaPage,
        OrdersTableTpvTicketPrintPage,
        MenuCreatePartialTitlePage,
        CustomersTicketsInvoicesListPage,
        CustomersElementsListPage,
        FilterPipeCustomerElementsEaten,
        ConfigurationVariationAddElementsPage,
        ConfigurationVariationsAddElementsSelectPage,
        ConfigurationVariationsAddElementsSelectedPage,
        ComboTemplateConorPage,
        ComboListPage,
        ComboPartialSharePage,
        ComboPartialRatioPage,
        TopMenuComboPage,
        ComboCreateTitlePage,
        ComboCreatePartialTitlePage,
        ComboCreatePartialDescriptionPage,
        ComboCreatePartialTagsPage,
        ComboCreateDishSelectPage,
        ComboPartialDishesSelectPage,
        ComboPartialDishesSelectedPage,
        ComboCreateFinishSectionPage,
        ComboCreatePricePage,
        ComboCreateImagePage,
        ComboCreateSelectTemplatePage,
        ComboTemplateBhPage,
        ComplementsCreateDishSelectPage,
        ComplementsPartialDishesSelectPage,
        ComplementsPartialDishesSelectedPage,
        PrinterSunmiSectionsPage,
        PrinterSunmiTagsPage,
        ComboCreateCustomizeViewPage,
        TpvTicketChangeTablePage,
        ConfigurationCloseCashViewPage,
        ConfigurationCloseCashViewPrintPage,
        TakeawayOrdersRecoverPage,
        TakeawayOrdersDeletePage,
        HomeDashboardBillingPage,
        HomeDashboardAlertsPage,
        TpvHoraryPage,
        TakeawayDeliveryFavoritesPage,
        TakeawaySelectState,
        TakeawayOrderInfoIntegrationPage,
        SelectBetweenDatetime,
        ConfigurationPrintersNativePrintPage,
        AnayliticsMenuComboPage,
        MctPayVerifonePage,
        AnalyticsSalesSalesViewPage,
        CartaViewSimulatorPage,
        ComboViewSimulatorPage,
        KitchenDeleteOrdersPage,
        NotificationsPage,
        PopupSelectPayment,
        PopupSelectDiscount,
        PrintTicketOrETicket,
        ConfigurationTicketsRatingsListPage,
        ModalRatings,
        PopupSelectCustomer,
        TakeawayOldDeleteOrdersPage,
        TakeawayOrdersStatePage,
        FilterPipeTakeaway,
        PaymentsType,
        ConfigurationPaymentMethodsPage,
        ConfigurationPaymentStripePage,
        ConfigurationPaymentPaypalPage,
        ConfigurationPaymentCryptoPage,
        ConfigurationPaymentVerifonePage,
        ConfigurationPaymentPayplazaPage,
        PhotoDishPage,
        PhotoProductPage,
        PhotoIngredientPage,
        PhotoComboPage,
        HomeUserBlock,
        PopupTicketRefund,
        ReservationConfig,
        ModalExtraInput,
        ConfigurationDomainsPage,
        PopupNewAppsPage,
        CartaTemplateTakeawayPage,
        ConfigurationRestWebEditCartaPage,
        AnalyticsPage,
        AnalyticsReportListPage,
        AnalyticsChart,
        SalesSalesPage,
        SalesAveragePage,
        SalesAveragePerDinerPage,
        SalesSalesPerM2Page,
        SalesZonesPage,
        SalesPerHourPage,
        SalesPersonsPerDayPage,
        SalesPaymentMethodsUsedPage,
        SalesFoodcostPage,
        SalesDiscountsPage,
        SalesTipsPage,
        ElementsTopSalesPage,
        ElementsTopSalesCategoryPage,
        ElementsFoodcostPage,
        ElementsAllergensPage,
        DeliveryTakeawaySalesPage,
        DeliveryTakeawaySalesAvgPage,
        DeliveryTakeawayPerDayPage,
        DeliveryTakeawaySalesTypePage,
        DeliveryTakeawaySalesMapPage,
        DeliveryTakeawaySalesElementsPage,
        DeliveryTakeawaySalesCategoriesPage,
        WaitersSalesPage,
        WaitersMovementsPage,
        PurchasesTotalPage,
        PurchasesPerElementPage,
        PurchasesPerCategoryPage,
        PurchasesPerProviderPage,
        CustomersTotalPage,
        CustomersNewPage,
        CustomersSalesPage,
        CustomersRetentionPage,
        StockSummaryPage,
        StockValuePage,
        ReservationsTotalPage,
        ReservationsAvgPersonsPerStripePerDayPage,
        ReservationsTopCustomersPage,
        KitchenTotalOrdersPage,
        KitchenAvgTimeCompleteOrderPage,
        KitchenDurationToCompleteDishPage,
        StockElementPage,
        StockMovementsPage,
        AnalyticsRealtimePage,
        PopupWaiterReportSales,
        CartaTemplateListPage,
        MenuTemplateListPage,
        MenuTemplateTakeawayPage,
        ComboTemplateListPage,
        ComboTemplateTakeawayPage,
        ComboPartialSectionNamePage,
        ComplementsPartialSectionNamePage,
        ReservationsAnulatedPage,
        SalesPerWeekPage,
        KitchenTotalOrdersElementsPage,
        HomeDashboardTkNoPaidPage,
        ConfigurationEstablishmentDeletePage,
        StockPercentageSalesPerDayPage,
        StockDaysInventoryLeftPage,
        StockCogsPage,
        TutorialDishesPage,
        TutorialStockPage,
        TutorialMenusCombosPage,
        TutorialCartaPage,
        TutorialSalesPage,
        TutorialIncomeExpensesPage,
        TutorialPedidosPage,
        TutorialReservasPage,
        TutorialInformesPage,
        TutorialOrderPage,
        TutorialTpvPage,
        TutorialKitchenPage,
        ConfigurationPuduRobotsPage,
        AddonsRealTimePage,
        StockAbcPage,
        ProductViewAddStockPage,
        ProductCreateWfoodcostAddStockPage,
        IngredientAddStockPage,
        StockCostEvolutionPage,
        HomeDashboardFreePage,
        RegisterPage,
        SetupInital3Page,
        InvoicesCreateSelectTicketsPage,
        ProductionOrderPage,
        PopupTicketStripeRefund,
        TicketsListArrosseriaPage,
        PriceCostPage,
        SelectDateTkPickupDay,
        SetupInital4Page,
        PopupTableWithTakeaway,
        SearcherRoomsTablesPage,
        TpvTicketSelectedListTicketPrintIndvPage,
        CartaMenuViewPage,
        CartasMenusListPage,
        ComponentCartaViewPage,
        ShareXxssPage,
        CompCreateDishPage,
        CompCreateProductPage,
        PopupFinishCreateElementPage,
        CartaEditNamePage,
        ComponentMenuViewPage,
        MenuEditNamePage,
        ComponentComboViewPage,
        ComboEditNamePage,
        HomeCartasMenusPage,
        HomeVersionPage,
        HomeArticlesPage,
        ReservationConfigCamps,
        ReservationConfigHorary,
        ReservationCalendarConfigPage,
        CompCreateReservationPage,
        ReservationCalendarDayViewPage,
        HomeReservationsPage,
        ArticlesListPage,
        ArticleViewPage,
        ArticleViewPhotoPage,
        ArticleViewPricePage,
        ArticleViewOthersPage,
        ArticleViewFoodcostPage,
        ArticleViewPreparationPage,
        ArticleViewNutritionPage,
        ArticleViewObservationsPage,
        ArticleViewStockPage,
        ArticleViewProvidersPage,
        ArticleViewAnalyticsPage,
        ArticleViewColorsPage,
        ArticleViewVariationsFavsPage,
        ArticleViewComplementsPage,
        ArticlesCreateTypePage,
        CompCreateIngredientPage,
        CompCreateDeliveryPage,
        ArticlesUpdatePricesPage,
        DeliberyNoteCreateTypePage,
        DeliberyNoteCreateFotoPage,
        PhotoAlbaranPage,
        DeliberyNoteResultFotoIa,
        DeliberyNoteProcessFotoIa,
        OdsViewPage,
        OdsListViewPage,
        OdsConfigurationViewPage,
        OdsConfigHoraryPage,
        OdsConfigShipmentPage,
        OdsConfigMenuPage,
        OdsConfigPaymentsPage,
        OdsConfigCustomizePage,
        CompCreateTakeawayPage,
        CompCreateProviderPage,
        ConfigurationPaymentRedsysPage,
        ConfigurationPaymentRedsysBizumPage,
        OdsConfigMenuCreatePage,
        OdsConfigMenuCreateSelectPage,
        OdsConfigMenuCreateSelectedPage,
        OdsConfigMenuCreateFinishPage,
        OdsConfigActiveElementsPage,
        ConfigurationPaymentTakeawayPage,
        OdsOrderInfoTicketPrintPage,
        OdsConfigModifyElementsPage,
        HomeOdsPage,
        HomePosPage,
        IngredientViewOthersPage,
        IngredientCreateFoodcostPricePage,
        IngredientCreateImagePage,
        TpvPanelPage,
        ConfigurationCloseCashCreate,
        IngredientViewLabelPage,
        ConfigurationCloseCashList,
        OurPlansPage,
        HomeImcomeExpensesPage,
        CompCreateTablePage,
        CompCreateRoomPage,
        ConfigurationPaymentsGetnetPage,
        ConfigurationPaymentGetnetTerminalPage,
        ConfigurationPaymentGetnetTopPage,
        ConfigurationIntegrationUberDirectPage,
        ConfigurationCloseCashViewPrintResumenPage,
        ConfigurationSecondDisplaImagesPage,
        ImportSalesPage,
        ConfigurationPaymentsComerciaGlobalPayPage,
        ConfigurationPaymentComerciaGlobalPayTopPage,
        ConfigurationIntegrationGlovoPage,
        ConfigurationAdvancedLogsPage
    ],
    imports: [
        BrowserModule,
        HttpModule,
        IonicModule.forRoot(MyApp, {}, 
{
  links: [
    
  ]
}),
        SweetAlert2Module.forRoot(),
        AngularFireModule.initializeApp(config),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFirestoreModule,
        AngularFirestoreModule.enablePersistence(),
        AngularFireStorageModule,
        IonTagsInputModule,
        BrowserAnimationsModule,
        ChartsModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        GooglePlaceModule,
        HttpClientModule,
        DragDropModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (setTranslateLoader),
                deps: [HttpClient]
            }
        }),
        QuillModule.forRoot(),
        NgxDatatableModule,
        ColorPickerModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage,
        HeaderPage,
        HeaderSchoolPage,
        SideMenuPage,
        SideMenuPageConfig,
        AllergensPage,
        PartialPageTitlePage,
        UploadImagePage,
        TagsPage,
        LoginPage,
        DishListPage,
        DishCreateNamePage,
        DishPartialTagsPage,
        DishTablePage,
        DishCreateAllergensPage,
        DishPartialAllergensPage,
        DishPartialIndicatorsPage,
        DishCreateImagePage,
        DishCreateFinishPage,
        DishViewPage,
        DishViewNamePage,
        DishViewTopPage,
        DishViewTagsPage,
        DishViewAllergensPage,
        DishViewListPage,
        DishViewPreparationPage,
        DishViewPhotoPage,
        DishViewGraphicsPage,
        DishFoodcostPersonsPage,
        DishIngredientsSelectPage,
        DishPartialIngredientsSelectPage,
        DishPartialIngredientsSelectedPage,
        DishIngredientsQuantityPage,
        DishPreparationPage,
        DishCreatePricePage,
        DishCreateObservationsPage,
        DishViewObservationsPage,
        ComponentsPopupsInviteFormModalComponent,
        MenuListPage,
        MenuPartialRatioPage,
        MenuPartialSharePage,
        MenuCreateSelectTypePage,
        MenuCreateTitlePage,
        MenuCreateDishSelectPage,
        MenuPartialDishesSelectPage,
        MenuPartialDishesSelectedPage,
        MenuCreatePricenextrasPage,
        MenuCreateCustomizeViewPage,
        MenuPartialCustomizeOptionsPage,
        MenuPartialCustomizeViewPage,
        MenuPartialCustomizeEditablePage,
        MenuPageCustomizeTemplatPage,
        MenuPageCustomizeSeparatorsPage,
        MenuXxssPage,
        MenuCreateExtrasPage,
        MenuPartialExtrasDishesSelectPage,
        MenuPartialExtrasDishesSelectedPage,
        IngredientListPage,
        IngredientCreateInfoPage,
        IngredientCreateStockPage,
        IngredientPartialTagsPage,
        IngredientCreateAllergensPage,
        IngredientPartialAllergensPage,
        IngredientPartialIndicatorsPage,
        IngredientCreateSelectProviderPage,
        IngredientPartialProviderSelectPage,
        IngredientPartialProviderSelectedPage,
        IngredientCreateProviderPricePage,
        IngredientCompCreateInfoPage,
        IngredientCompPartialTagsPage,
        IngredientCompCreateSelectIngPage,
        IngredientCompPartialIngSelectPage,
        IngredientCompPartialIngSelectedPage,
        IngredientCompQuantityCostPage,
        IngredientCompCreateStock,
        IngredientViewPage,
        IngredientViewNamePage,
        IngredientViewTagsPage,
        IngredientViewProvidersPage,
        IngredientViewAllergensPage,
        IngredientViewGraphicsPage,
        IngredientViewFoodcostPage,
        IngredientCompCreatePreparationPage,
        IngredientCompCreateImagePage,
        IngredientViewPreparationPage,
        IngredientViewPhotoPage,
        IngredientCreateSelectType,
        IngredientCreateObservationsPage,
        IngredientViewObservationsPage,
        ProductListPage,
        ProductCreateSelectTypePage,
        ProductCreateWfoodcostInfoPage,
        ProductCreateWfoodcostStockPage,
        ProductPartialWfoodcostTagsPage,
        ProductCreateWfoodcostAllergensPage,
        ProductPartialWfoodcostAllergensPage,
        ProductPartialWfoodcostIndicatorsPage,
        ProductCreateWfoodcostSelectProviderPage,
        ProductPartialWfoodcostProviderSelectPage,
        ProductPartialWfoodcostProviderSelectedPage,
        ProductCreateWfoodcostProviderPricePage,
        ProductCreateWfoodcostImagePage,
        ProductCreateWfoodcostPricePage,
        ProductCreateFoodcostInfoPage,
        ProductPartialFoodcostTagsPage,
        ProductCreateFoodcostSelectIngPage,
        ProductPartialFoodcostIngSelectedPage,
        ProductPartialFoodcostIngSelectPage,
        ProductCreateFoodcostQuantityCostPage,
        ProductCreateFoodcostPreparationPage,
        ProductCreateFoodcostImagePage,
        ProductCreateFoodcostPricePage,
        ProductViewPage,
        ProductViewNamePage,
        ProductViewStockPage,
        ProductViewTopPage,
        ProductViewAllergensPage,
        ProductViewTagsPage,
        ProductViewListPage,
        ProductViewPreparationPage,
        ProductViewPhotoPage,
        ProductViewGraphicsPage,
        ProductCreateObservationsPage,
        ProductViewObservationsPage,
        ReservationCalendarPage,
        ReservationDayPage,
        ReservationCreatePage,
        ReservationLoaderPage,
        TpvRoomPage,
        TpvRoomMenuPage,
        TpvSelectRoomPage,
        //TpvSelectTakeAwayPage,
        TpvTicketPage,
        TpvTicketMenuPage,
        TpvTicketSelectPage,
        TpvTicketSelectedPage,
        TpvLoaderPage,
        StockListPage,
        TpvTicketSelectedListTicketPage,
        TpvTicketSelectedPersonsPage,
        TpvKeyboardExportableComponent,
        TpvTicketSelectedListTicketPrintPage,
        TpvTicketSelectedCashPage,
        TpvCashInoutCreatePage,
        ConfigurationPage,
        ConfigurationRoomsPage,
        ConfigurationRoomsCreatePage,
        ConfigurationRoomsCreateTablePage,
        ConfigurationEstablishmentCreatePage,
        ConfigurationPasswordPage,
        ConfigurationUsersPage,
        ConfigurationUsersCreatePage,
        ConfigurationTicketsPage,
        ConfigurationTicketsCreatePage,
        ConfigurationTicketsListPage,
        ConfigurationCashsPage,
        ConfigurationCashsCreatePage,
        ConfigurationVariationsPage,
        ConfigurationVariationCreateSelectTypePage,
        ConfigurationVariationCreateListPage,
        ConfigurationVariationsCreateInfoPage,
        ConfigurationComplementsPage,
        ConfigurationComplementsCreateListPage,
        ConfigurationSocialPage,
        TpvTicketSelectedPayPage,
        TpvTicketSelectedPayIndvPage,
        StockListPage,
        StockProviderListPage,
        DeliberyNoteListPage,
        DeliberyNoteCreateSelectProviderPage,
        DeliberyNoteCreateSelectIngprodPage,
        DeliberyNoteCreatePartialIngprodSelectPage,
        DeliberyNoteCreatePartialIngprodSelectedPage,
        DeliberyNoteCreateIngprodPricePage,
        DeliberyNoteViewPage,
        DeliberyNoteViewInfoPage,
        DeliberyNoteViewListPage,
        IncomeExpensesListPage,
        IncomeCreateDataPage,
        ExpensesCreateDataPage,
        ProvidersCreateDataPage,
        KitchenPage,
        SuperPage,
        PasswordRecoveryPage,
        SetupPage,
        SetupInital2Page,
        MenuPartialCustomizeViewA5Page,
        HiddenScreenPage,
        CustomersListPage,
        CustomersCreateDataPage,
        InvoicesCreateSelectClientPage,
        InvoicesListPage,
        InvoicesViewPage,
        KitchenHistoryPage,
        ConfigurationImagesPage,
        FinishProcessPage,
        HelpBottomPage,
        HelpPage,
        DishTutorialSlidePage,
        MenuTutorialSlidePage,
        OrdersLoaderPage,
        OrdersRoomPage,
        OrdersSelectRoomPage,
        OrdersSelectRoomMenuPage,
        OrdersTablePage,
        OrdersTableInfoPage,
        OrdersTableListPage,
        OrdersTableButtonsPage,
        OrdersSelectPage,
        OrdersSelectSelectPage,
        OrdersSelectMenuPage,
        OrdersSelectSelectedPage,
        OrdersSelectSelectedListPage,
        OrdersUpDelPage,
        OrdersSelectSelectedPersonsPage,
        OrdersKeyboardExportableComponent,
        OrdersPositionsPage,
        OrdersTableInfoPrintPage,
        IngredientTutorialSlidePage,
        ProductTutorialSlidePage,
        TpvTutorialSlidePage,
        ReservationTutorialSlidePage,
        StockTutorialSlidePage,
        InexpTutorialSlidePage,
        ConfigurationTutorialSlidePage,
        AddonsTutorialSlidePage,
        DashboardTutorialSlidePage,
        NameLangPage,
        TakeawayLoaderPage,
        TakeawayOrdersPage,
        TakeawayOrdersMenuPage,
        TakeawaySelectOrdersPage,
        TakeawayCreateSelectCustomerPage,
        TakeawayOrderPage,
        TakeawayOrderButtonsPage,
        TakeawayOrderInfoPage,
        TakeawayOrderInfoPrintPage,
        TakeawayOrderListPage,
        TakeawayOrderSelectPage,
        TakeawayOrderSelectSelectPage,
        TakeawayOrderSelectSelectPage,
        TakeawayOrderSelectMenuPage,
        TakeawayOrderSelectSelectedPage,
        TakeawayOrderSelectSelectedListPage,
        TakeawayOrderUpDelPage,
        TakeawayOrderPayPage,
        TakeawayOrderInfoTicketPrintPage,
        BlockScreenPage,
        TpvTicketShowListDetailsPage,
        TakeawayOrderSelectSelectedPersonsPage,
        MultiPage,
        MenuCreateFinishSectionPage,
        AlertMessagePage,
        WeatherPage,
        SalesListPage,
        ProgressBarPage,
        ProviderOrderCartPage,
        ProviderOrderAddPage,
        ProviderOrderAddDishPage,
        SalesAnalyticsPage,
        ProviderOrderListPage,
        ProviderOrderViewPage,
        TpvTicketSelectElementPage,
        TpvTicketInviteDiscountElementPage,
        TpvTicketDiscountRestaurantticketPage,
        TakeawayOrderInviteDiscountElementPage,
        TakeawayOrderDiscountRestaurantticketPage,
        ExpensesDenoCreateDataPage,
        ExpensesDenoCreateSelectDenoPage,
        ExpensesDenoPartialDenoSelectPage,
        ExpensesDenoPartialDenoSelectedPage,
        ExpensesDenoCreateSeparatePercetagePage,
        CartaListPage,
        CartaCreateSelectTypePage,
        CartaCreateDishProdSelectPage,
        CartaPartialDishProdSelectPage,
        CartaPartialDishProdSelectedPage,
        CartaCreateListDetailsPage,
        CartaCreateFinishSectionPage,
        CartaCreateCustomizeViewPage,
        CartaPartialCustomizeEditablePage,
        CartaPartialCustomizeOptionsPage,
        CartaPageCustomizeTemplatPage,
        CartaPageCustomizeSeparatorsPage,
        CartaPartialCustomizeViewPage,
        HomePrincipalPage,
        TeachersListPage,
        TeachersCreatePage,
        StudentsCreatePage,
        StudentsListPage,
        ClassroomsListPage,
        ClassroomsCreateTeachersSelectPage,
        ClassroomsPartialTeachersSelectPage,
        ClassroomsPartialTeachersSelectedPage,
        ClassroomsCreateStudentsSelectPage,
        ClassroomsPartialStudentsSelectPage,
        ClassroomsPartialStudentsSelectedPage,
        TeachersViewPage,
        StudentsViewPage,
        ClassroomsViewPage,
        HomeTeacherPage,
        ClassroomsStudentsListPage,
        DescriptionLangPage,
        ProvidersAddSelectElementsPage,
        ProvidersPartialIngredientsSelectPage,
        ProvidersPartialIngredientsSelectedPage,
        ProvidersPartialProductsSelectPage,
        ProvidersPartialProductsSelectedPage,
        VariationsDishSelectorPage,
        ConfigurationUsersScreenBlockPage,
        ConfigurationUsersScreenBlockCreatePage,
        StartScreensPage,
        ConfigurationLogsPage,
        TutorialBox,
        TutorialBoxDish,
        TutorialBoxMenu,
        TutorialBoxSale,
        ConfigurationThermalPrintersPage,
        ConfigurationPrintersStarprntPage,
        ConfigurationPrintersNativePage,
        ConfigurationPrintersWizardTypePage,
        ConfigurationPrintersWizardListPage,
        ConfigurationTicketPrintPage,
        InvoicesTicketPrintPage,
        ConfigurationPrintersPrintservicesPage,
        MostSalesElementsComponent,
        HomeDashboardPage,
        KitchenOrderPrintPage,
        ConfigurationIntegrationsPage,
        StaticAlertPage,
        StaticsUpdatePage,
        VariationsProductSelectorPage,
        ConfigurationPrintersSunmiPage,
        ImportExcelPage,
        ImportFinishPage,
        ConfigurationTipsPage,
        TipsPage,
        PopupPrintPage,
        DatetimeLocationPage,
        PopupErrorsPage,
        PosDishPage,
        PosProductPage,
        PosMenuPage,
        PosFavouritePage,
        VariationsCreateFavSelectPage,
        VariationsPartialFavSelectPage,
        VariationsPartialFavSelectedPage,
        ComplementsCreateSelectPage,
        ComplementsPartialSelectPage,
        ComplementsPartialSelectedPage,
        DishBiPage,
        ConfigurationPartialRoomsCreateNamePage,
        ConfigurationPartialRoomsCreateMapPage,
        ConfigurationPartialRoomsCreateListPage,
        DishViewPrintLabelPage,
        DishViewLabelPage,
        FlagsLangPage,
        ViewNameDescLangPage,
        DishPartialNamePage,
        DishPartialDescriptionPage,
        ProductCreatePartialNamePage,
        ProductCreatePartialDescriptionPage,
        DishCreateNutritionPage,
        DishViewNutritionPage,
        TopStockPage,
        MinMaxListPage,
        ProviderFilePage,
        ProviderAdsPage,
        ProviderListSelectPage,
        ProviderNewPage,
        ProviderDashboardPage,
        ProductsAdsPage,
        ProductsStockPage,
        KitchenSectionsPage,
        TakeawayOrderInfoCustomerPage,
        TopReservationsPage,
        ReservationPendingListPage,
        ReservationAcceptedListPage,
        ReservationDeniedListPage,
        DeniedReservationPage,
        SearcherCustomersPage,
        ConfigurationDeliveriesPage,
        ConfigurationDeliveriesCreatePage,
        TakeawayOrderNotesPage,
        PosComboPage,
        PosListElementsPage,
        ConfigurationIntegrationsPopupPage,
        ReservationManualCreatePage,
        SelectedPersonsPage,
        ConfigurationPaymentsChargesPage,
        ConfigurationRestWebPage,
        ConfigurationRestWebZipcodePage,
        ConfigurationViewChargePage,
        StockListUpdateInventoryPage,
        PosElementPersonPage,
        ConfigurationOrdersPage,
        ConfigurationRestWebSchedulePage,
        PopupInfoPage,
        OrdersTableNotesPage,
        VersionProPage,
        AddonsUserArrivalPage,
        AddonsTriggerVersionProPage,
        MenuCreateSelectTemplatePage,
        MenuTemplateCamaroPage,
        MenuTemplateChallengerPage,
        MenuTemplateTiguanPage,
        MenuTemplateFordFocusPage,
        MenuTemplateAudiPage,
        MenuTemplateAudiA1Page,
        MenuTemplateMercedesPage,
        CartaCreateSelectTemplatePage,
        CartaTemplateGladiusPage,
        CartaTemplateCotaPage,
        CartaTemplateCota25Page,
        CartaTemplateTmaxPage,
        CartaTemplateAeroxPage,
        CartaTemplateBultacoPage,
        CartaTemplateScoopyPage,
        CartaTemplateTyphoonPage,
        CartaTemplateOssaPage,
        CartaTemplatePuchPage,
        CartaTemplateVespaPage,
        CartaTemplateRd350Page,
        CartaTemplateP200Page,
        CustomersCreateInfoPage,
        LoginPreviewPage,
        AddonsVersionProPage,
        AddonsVersionProCancelPage,
        KitchenOrderSectionsPage,
        KitchenOrderTagsPage,
        PrinterSunmiAutoPage,
        PrinterSunmiQueuePage,
        PrinterSunmiConfPage,
        PrinterSunmiInfoPage,
        MenuTemplateFirebirdPage,
        CartaTemplateVespinoPage,
        CartaTemplateJogPage,
        CartaTemplateVariantPage,
        MenuTemplateMultiplaPage,
        OrdersTableTpvTicketPrintPage,
        MenuCreatePartialTitlePage,
        CustomersTicketsInvoicesListPage,
        CustomersElementsListPage,
        ConfigurationVariationAddElementsPage,
        ConfigurationVariationsAddElementsSelectPage,
        ConfigurationVariationsAddElementsSelectedPage,
        ComboTemplateConorPage,
        ComboListPage,
        ComboPartialSharePage,
        ComboPartialRatioPage,
        TopMenuComboPage,
        ComboCreateTitlePage,
        ComboCreatePartialTitlePage,
        ComboCreatePartialDescriptionPage,
        ComboCreatePartialTagsPage,
        ComboCreateDishSelectPage,
        ComboPartialDishesSelectPage,
        ComboPartialDishesSelectedPage,
        ComboCreateFinishSectionPage,
        ComboCreatePricePage,
        ComboCreateImagePage,
        ComboCreateSelectTemplatePage,
        ComboTemplateBhPage,
        ComplementsCreateDishSelectPage,
        ComplementsPartialDishesSelectPage,
        ComplementsPartialDishesSelectedPage,
        PrinterSunmiSectionsPage,
        PrinterSunmiTagsPage,
        ComboCreateCustomizeViewPage,
        TpvTicketChangeTablePage,
        ConfigurationCloseCashViewPage,
        ConfigurationCloseCashViewPrintPage,
        TakeawayOrdersRecoverPage,
        TakeawayOrdersDeletePage,
        HomeDashboardBillingPage,
        HomeDashboardAlertsPage,
        TpvHoraryPage,
        TakeawayDeliveryFavoritesPage,
        TakeawaySelectState,
        TakeawayOrderInfoIntegrationPage,
        SelectBetweenDatetime,
        ConfigurationPrintersNativePrintPage,
        AnayliticsMenuComboPage,
        MctPayVerifonePage,
        AnalyticsSalesSalesViewPage,
        CartaViewSimulatorPage,
        ComboViewSimulatorPage,
        KitchenDeleteOrdersPage,
        NotificationsPage,
        PopupSelectPayment,
        PopupSelectDiscount,
        PrintTicketOrETicket,
        ConfigurationTicketsRatingsListPage,
        ModalRatings,
        PopupSelectCustomer,
        TakeawayOldDeleteOrdersPage,
        TakeawayOrdersStatePage,
        PaymentsType,
        ConfigurationPaymentMethodsPage,
        ConfigurationPaymentStripePage,
        ConfigurationPaymentPaypalPage,
        ConfigurationPaymentCryptoPage,
        ConfigurationPaymentVerifonePage,
        ConfigurationPaymentPayplazaPage,
        PhotoDishPage,
        PhotoProductPage,
        PhotoIngredientPage,
        PhotoComboPage,
        HomeUserBlock,
        PopupTicketRefund,
        ReservationConfig,
        ModalExtraInput,
        ConfigurationDomainsPage,
        PopupNewAppsPage,
        CartaTemplateTakeawayPage,
        ConfigurationRestWebEditCartaPage,
        AnalyticsPage,
        AnalyticsReportListPage,
        AnalyticsChart,
        SalesSalesPage,
        SalesAveragePage,
        SalesAveragePerDinerPage,
        SalesSalesPerM2Page,
        SalesZonesPage,
        SalesPerHourPage,
        SalesPersonsPerDayPage,
        SalesPaymentMethodsUsedPage,
        SalesFoodcostPage,
        SalesDiscountsPage,
        SalesTipsPage,
        ElementsTopSalesPage,
        ElementsTopSalesCategoryPage,
        ElementsFoodcostPage,
        ElementsAllergensPage,
        DeliveryTakeawaySalesPage,
        DeliveryTakeawaySalesAvgPage,
        DeliveryTakeawayPerDayPage,
        DeliveryTakeawaySalesTypePage,
        DeliveryTakeawaySalesMapPage,
        DeliveryTakeawaySalesElementsPage,
        DeliveryTakeawaySalesCategoriesPage,
        WaitersSalesPage,
        WaitersMovementsPage,
        PurchasesTotalPage,
        PurchasesPerElementPage,
        PurchasesPerCategoryPage,
        PurchasesPerProviderPage,
        CustomersTotalPage,
        CustomersNewPage,
        CustomersSalesPage,
        CustomersRetentionPage,
        StockSummaryPage,
        StockValuePage,
        ReservationsTotalPage,
        ReservationsAvgPersonsPerStripePerDayPage,
        ReservationsTopCustomersPage,
        KitchenTotalOrdersPage,
        KitchenAvgTimeCompleteOrderPage,
        KitchenDurationToCompleteDishPage,
        StockElementPage,
        StockMovementsPage,
        AnalyticsRealtimePage,
        PopupWaiterReportSales,
        CartaTemplateListPage,
        MenuTemplateListPage,
        MenuTemplateTakeawayPage,
        ComboTemplateListPage,
        ComboTemplateTakeawayPage,
        ComboPartialSectionNamePage,
        ComplementsPartialSectionNamePage,
        ReservationsAnulatedPage,
        SalesPerWeekPage,
        KitchenTotalOrdersElementsPage,
        HomeDashboardTkNoPaidPage,
        ConfigurationEstablishmentDeletePage,
        StockPercentageSalesPerDayPage,
        StockDaysInventoryLeftPage,
        StockCogsPage,
        TutorialDishesPage,
        TutorialStockPage,
        TutorialMenusCombosPage,
        TutorialCartaPage,
        TutorialSalesPage,
        TutorialIncomeExpensesPage,
        TutorialPedidosPage,
        TutorialReservasPage,
        TutorialInformesPage,
        TutorialOrderPage,
        TutorialTpvPage,
        TutorialKitchenPage,
        ConfigurationPuduRobotsPage,
        AddonsRealTimePage,
        StockAbcPage,
        ProductViewAddStockPage,
        ProductCreateWfoodcostAddStockPage,
        IngredientAddStockPage,
        StockCostEvolutionPage,
        HomeDashboardFreePage,
        RegisterPage,
        SetupInital3Page,
        InvoicesCreateSelectTicketsPage,
        ProductionOrderPage,
        PopupTicketStripeRefund,
        TicketsListArrosseriaPage,
        PriceCostPage,
        SelectDateTkPickupDay,
        SetupInital4Page,
        PopupTableWithTakeaway,
        SearcherRoomsTablesPage,
        TpvTicketSelectedListTicketPrintIndvPage,
        CartaMenuViewPage,
        CartasMenusListPage,
        ComponentCartaViewPage,
        ShareXxssPage,
        CompCreateDishPage,
        CompCreateProductPage,
        PopupFinishCreateElementPage,
        CartaEditNamePage,
        ComponentMenuViewPage,
        MenuEditNamePage,
        ComponentComboViewPage,
        ComboEditNamePage,
        HomeCartasMenusPage,
        HomeVersionPage,
        HomeArticlesPage,
        ReservationConfigCamps,
        ReservationConfigHorary,
        ReservationCalendarConfigPage,
        CompCreateReservationPage,
        ReservationCalendarDayViewPage,
        HomeReservationsPage,
        ArticlesListPage,
        ArticleViewPage,
        ArticleViewPhotoPage,
        ArticleViewPricePage,
        ArticleViewOthersPage,
        ArticleViewFoodcostPage,
        ArticleViewPreparationPage,
        ArticleViewNutritionPage,
        ArticleViewObservationsPage,
        ArticleViewStockPage,
        ArticleViewProvidersPage,
        ArticleViewAnalyticsPage,
        ArticleViewColorsPage,
        ArticleViewVariationsFavsPage,
        ArticleViewComplementsPage,
        ArticlesCreateTypePage,
        CompCreateIngredientPage,
        CompCreateDeliveryPage,
        ArticlesUpdatePricesPage,
        DeliberyNoteCreateTypePage,
        DeliberyNoteCreateFotoPage,
        PhotoAlbaranPage,
        DeliberyNoteResultFotoIa,
        DeliberyNoteProcessFotoIa,
        OdsViewPage,
        OdsListViewPage,
        OdsConfigurationViewPage,
        OdsConfigHoraryPage,
        OdsConfigShipmentPage,
        OdsConfigMenuPage,
        OdsConfigPaymentsPage,
        OdsConfigCustomizePage,
        CompCreateTakeawayPage,
        CompCreateProviderPage,
        ConfigurationPaymentRedsysPage,
        ConfigurationPaymentRedsysBizumPage,
        OdsConfigMenuCreatePage,
        OdsConfigMenuCreateSelectPage,
        OdsConfigMenuCreateSelectedPage,
        OdsConfigMenuCreateFinishPage,
        OdsConfigActiveElementsPage,
        ConfigurationPaymentTakeawayPage,
        OdsOrderInfoTicketPrintPage,
        OdsConfigModifyElementsPage,
        HomeOdsPage,
        HomePosPage,
        IngredientViewOthersPage,
        IngredientCreateFoodcostPricePage,
        IngredientCreateImagePage,
        TpvPanelPage,
        ConfigurationCloseCashCreate,
        IngredientViewLabelPage,
        ConfigurationCloseCashList,
        OurPlansPage,
        HomeImcomeExpensesPage,
        CompCreateTablePage,
        CompCreateRoomPage,
        ConfigurationPaymentsGetnetPage,
        ConfigurationPaymentGetnetTerminalPage,
        ConfigurationPaymentGetnetTopPage,
        ConfigurationIntegrationUberDirectPage,
        ConfigurationCloseCashViewPrintResumenPage,
        ConfigurationSecondDisplaImagesPage,
        ImportSalesPage,
        ConfigurationPaymentsComerciaGlobalPayPage,
        ConfigurationPaymentComerciaGlobalPayTopPage,
        ConfigurationIntegrationGlovoPage,
        ConfigurationAdvancedLogsPage,
    ],
    providers: [
        StatusBar,
        BackgroundMode,
        SplashScreen,
        ScreenOrientation,
        HttpModule,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        Globals,
        DishServices,
        MenuServices,
        TPVServices,
        IngredientsServices,
        ProductsServices,
        ProvidersServices,
        ReservationsServices,
        TemplatesServices,
        SeparatorServices,
        StockServices,
        IncomeExpensesServices,
        DeliberyNoteServices,
        ConfigurationServices,
        OrdersServices,
        AuthServices,
        Uploads,
        PrintServices,
        DatePipe,
        Printer,
        CustomersServices,
        InvoicesServices,
        ExportServices,
        HTTP,
        StaticsServices,
        CurrencyPipe,
        OrdersCoServices,
        CurrencyPipe,
        NativeAudio,
        TakeawayServices,
        SalesServices,
        CartaServices,
        SchoolServices,
        AddonsServices,
        StarPRNT,
        AlegraServices,
        Network,
        NativeStorage,
        AdsServices,
        QRServices,
        SearchServices,
        ComboServices,
        Device,
        InAppBrowser,
        AnalyticsServices,
        Push,
        NotificationsServices,
        Deeplinks,
        AdvancedAnalyticsServices,
        CustomServices,
        SearchReservationsServices,
        CartaMenuServices,
        EmailServices,
        ArticlesServices,
        OdsServices,
        AIServices,
        /** RollBar **/
        { provide: ErrorHandler, useClass: RollbarErrorHandler },
        { provide: RollbarService, useFactory: rollbarFactory },
    ]
})
export class AppModule {
}
//https://davidea.st/articles/firebase-bundle-size





// WEBPACK FOOTER //
// ./src/app/app.module.ts